<template>
  <div class="T">
    <!-- 面包屑：名称与菜单配置同步 -->
    <AppBreadcrumb :items="[{ path: 'Parameter' }]" />
    <!--电脑端 搜索 -->
    <div class="suso suso-desktop">
      <el-form>
        <el-form-item>
          <el-input :placeholder="('请搜索关键字进行查询')" clearable v-model.trim="famlis.search_content" ></el-input>
          <el-button class="formBtn" type="primary" @click="pay_search">{{ $t('waterMeter.查询') }}</el-button>
          <el-button class="formBtn" type="primary" @click="shuaxin">{{ $t('waterMeter.重选') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.小区')+':'" class="elform">
            <el-select v-model="famlis.community_id" :placeholder="$t('waterMeter.请选择小区')" size="small" clearable
            @change="selectQuarters(famlis.community_id)">
              <el-option
                v-for="item in quarters"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.楼栋')+':'" class="elform">
            <el-select v-model="famlis.building_id" :placeholder="$t('waterMeter.请选择楼栋')" size="small" clearable
            @change="selectBuildings(famlis.building_id)">
              <el-option
                v-for="item in Buildings"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.单元')+':'" class="elform">
            <el-select v-model="famlis.unit_id" :placeholder="$t('waterMeter.请选择单元')" size="small" clearable
            @change="selectunit(famlis.unit_id)">
              <el-option
                v-for="item in units"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option> 
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.房间')+':'" class="elform">
            <el-select v-model="famlis.room_id" :placeholder="$t('waterMeter.请选择房间')" size="small" clearable
            @change="selectroom(famlis.room_id)">
              <el-option
                v-for="item in roomsfas"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="欠费状态:" class="elform">
            <el-select v-model="famlis.owing" @change="seleYuer(famlis.owing)" clearable placeholder="请选择欠费状态"  size="small"
            >
              <el-option
                v-for="item in yugecans"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <!-- <el-form-item label="阀门状态:" class="elform">
            <el-select v-model="famlis.valveStatus" @change="seleValveStatus(famlis.valveStatus)" clearable placeholder="请选择阀门状态"  size="small"
            >
              <el-option
                v-for="item in valveStatuses"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item style="margin-left: 10px">
          <el-button class="elfomobtn" type="primary" @click="pay_search" size="medium ">{{ $t('waterMeter.查询') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button class="elfomobtn" type="primary" @click="shuaxin" size="small">{{ $t('waterMeter.重选') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <!-- <el-button type="primary" size="small">批 量 导 出</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <!-- 手机端 搜索 -->
    <div class="suso suso-mobile">
      <el-form>
        <el-form-item>
          <el-input :placeholder="('搜索关键字查询')" clearable v-model.trim="famlis.search_content" ></el-input>
        </el-form-item>
          <el-form-item label="欠费状态" class="elform">
            <el-select v-model="famlis.owing" @change="seleYuer(famlis.owing)" clearable placeholder="请选择欠费状态" size="small" popper-class="mobile-select-popper"
            >
              <el-option
                v-for="item in yugecans"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        </el-form>
        <el-form>
        <el-form-item :label="$t('waterMeter.小区')+':'" class="elform">
            <el-select v-model="famlis.community_id" :placeholder="$t('waterMeter.请选择小区')" size="small" clearable popper-class="mobile-select-popper"
            @change="selectQuarters(famlis.community_id)">
              <el-option
                v-for="item in quarters"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.楼栋')+':'" class="elform">
            <el-select v-model="famlis.building_id" :placeholder="$t('waterMeter.请选择楼栋')" size="small" clearable popper-class="mobile-select-popper"
            @change="selectBuildings(famlis.building_id)">
              <el-option
                v-for="item in Buildings"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        </el-form>
        <el-form>
        <el-form-item :label="$t('waterMeter.单元')+':'" class="elform">
            <el-select v-model="famlis.unit_id" :placeholder="$t('waterMeter.请选择单元')" size="small" clearable popper-class="mobile-select-popper"
            @change="selectunit(famlis.unit_id)">
              <el-option
                v-for="item in units"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('waterMeter.房间')+':'" class="elform">
            <el-select v-model="famlis.room_id" :placeholder="$t('waterMeter.请选择房间')" size="small" clearable popper-class="mobile-select-popper"
            @change="selectroom(famlis.room_id)">
              <el-option
                v-for="item in roomsfas"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <el-form class="mobile-query-actions">
        <el-form-item>
          <el-button class="formBtn" type="primary" @click="pay_search">{{ $t('waterMeter.查询') }}</el-button>
          <el-button class="formBtn" type="primary" @click="shuaxin">{{ $t('waterMeter.重选') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 按钮区域 -->
    <div class="ButtonArea">
        <div>
          <el-dropdown trigger="click" :hide-on-click="true" @command="handleValveControlCommand">
            <el-button type="primary">
                {{ $t('waterMeter.阀门控制') }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="open">{{ $t('waterMeter.开阀') }}</el-dropdown-item>
                <el-dropdown-item command="close">{{ $t('waterMeter.关阀') }}</el-dropdown-item>
                <el-dropdown-item command="alarmClose">{{ $t('waterMeter.报警关阀') }}</el-dropdown-item>
                <el-dropdown-item command="test">{{ $t('waterMeter.阀门测试') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div><el-button @click="zqiosbtn">{{ $t('waterMeter.周期上传参数') }}</el-button></div>
        <div><el-button @click="fixedbtn">{{ $t('waterMeter.定点上传参数') }}</el-button></div>
        <div><el-button @click="Dailybtn">{{ $t('waterMeter.日冻结参数') }}</el-button></div>
        <div><el-button @click="Monthlybtn">{{ $t('waterMeter.月冻结参数') }}</el-button></div>
        <div><el-button @click="ridojie">{{ $t('waterMeter.日冻结数据') }}</el-button></div>
        <div><el-button @click="yuedata">{{ $t('waterMeter.月冻结数据') }}</el-button></div>
        <div><el-button @click="quyuDaochu">{{ $t('waterMeter.区域导出') }}</el-button></div>
        <!-- <div><el-button>报警上传参数</el-button></div> -->
    </div>
    <!-- 按钮区域 -->
    <!-- <div class="ButtonArea">
        <div><el-button @click="ridojie">日冻结数据</el-button></div>
        <div><el-button @click="yuedata">月冻结数据</el-button></div>
    </div> -->
    <!-- 内容区域pc端 -->
    <div class="tab">
      <el-card>
        <el-table
        ref="historyTable"
        :data="parData"
        tooltip-effect="dark"
        style="width: 100%"
        height='500'
        highlight-current-row
        @selection-change="handleSelectionChange"
        :row-class-name="rowStyle">
        <el-table-column
        type="selection"
        width="50">
        </el-table-column>
        <el-table-column
        prop="pay_id"
        :label="$t('waterMeter.缴费编号')"
        width="120"
        v-if="visibleList.includes(0)">
        </el-table-column>
        <el-table-column
        prop="meter_id"
        :label="$t('waterMeter.水表编号')"
        width="130"
        :show-overflow-tooltip="true"
        v-if="visibleList.includes(1)">
        </el-table-column>
        <el-table-column
        prop="username"
        :label="$t('waterMeter.用户名')"
        min-width="150"
        :show-overflow-tooltip="false"
        class-name="cell-wrap"
        v-if="visibleList.includes(2)">
          <template slot-scope="scope">
            <div class="cell-content-wrap" style="white-space: normal; word-break: break-all; word-wrap: break-word; overflow: visible;">{{ scope.row.username }}</div>
          </template>
        </el-table-column>
        <el-table-column
        prop="address"
        :label="$t('waterMeter.位置')"
        min-width="200"
        :show-overflow-tooltip="false"
        class-name="cell-wrap"
        v-if="visibleList.includes(3)">
          <template slot-scope="scope">
            <div class="cell-content-wrap" style="white-space: normal; word-break: break-all; word-wrap: break-word; overflow: visible;">{{ scope.row.address }}</div>
          </template>
        </el-table-column>
        <el-table-column
        prop="balance"
        :label="$t('waterMeter.余额')"
        width="80"
        :show-overflow-tooltip="true"
        v-if="visibleList.includes(4)">
        </el-table-column>
        <el-table-column
        prop="sumFlow"
        :label="$t('waterMeter.正向累计流量')"
        width="120"
        v-if="visibleList.includes(5)">
        </el-table-column>
        <el-table-column
        prop="netAccumulation"
        :label="$t('waterMeter.净累计流量')"
        width="120"
        v-if="visibleList.includes(6)">
        </el-table-column>
        <el-table-column
        prop="reverseAccumulation"
        :label="$t('waterMeter.反向累计流量')"
        width="120"
        v-if="visibleList.includes(7)">
        </el-table-column>
        <el-table-column
        prop="atAccumulation"
        :label="$t('waterMeter.瞬时流量')"
        width="120"
        show-overflow-tooltip
        v-if="visibleList.includes(8)">
        </el-table-column>
        <el-table-column
        prop="plotReceiveTime"
        :label="$t('waterMeter.最新上报时间')"
        width="150"
        :show-overflow-tooltip="true"
        v-if="visibleList.includes(9)">
        </el-table-column>
        <el-table-column
        prop="yaLiF"
        :label="$t('waterMeter.压力')"
        width="120"
        show-overflow-tooltip
        v-if="visibleList.includes(10)">
        </el-table-column>
        <el-table-column
        prop="valveStatus"
        :label="$t('waterMeter.阀门状态')"
        width="120"
        show-overflow-tooltip
        v-if="visibleList.includes(11)">
        </el-table-column>
        <el-table-column
        prop="signallntensity"
        :label="$t('waterMeter.信号强度')"
        width="150"
        show-overflow-tooltip
        v-if="visibleList.includes(12)">
        </el-table-column>
        <el-table-column
        prop="batteryVoltage"
        :label="$t('waterMeter.电池电压')"
        width="150"
        show-overflow-tooltip
        v-if="visibleList.includes(13)">
        </el-table-column>
        <el-table-column
        prop="zhuangTaiLouShui"
        :label="$t('waterMeter.漏水报警')"
        width="120"
        show-overflow-tooltip
        v-if="visibleList.includes(14)">
        </el-table-column>
        <el-table-column
        prop="zhuangTaiYeweibaojing"
        :label="$t('waterMeter.液位报警')"
        width="120"
        show-overflow-tooltip
        v-if="visibleList.includes(15)">
        </el-table-column>
        <el-table-column
        prop="zhuangTaiFanXiangJiLiang"
        :label="$t('waterMeter.反向计量')"
        width="150"
        show-overflow-tooltip
        v-if="visibleList.includes(16)">
        </el-table-column>
        <el-table-column
        prop="zhuangTaiLiuLiangChaoShangXian"
        :label="$t('waterMeter.流量超限')"
        width="120"
        show-overflow-tooltip
        v-if="visibleList.includes(17)">
        </el-table-column>
        <el-table-column
        prop="magneticAttack"
        :label="$t('waterMeter.磁攻击')"
        width="150"
        show-overflow-tooltip
        v-if="visibleList.includes(18)">
        </el-table-column>
        <el-table-column
        property="zhuangTaiChaiXieZhuangTai"
        :label="$t('waterMeter.拆卸状态')"
        width="170"
        show-overflow-tooltip
        v-if="visibleList.includes(19)">
        </el-table-column>
        <el-table-column
        prop="powerLow"
        :label="$t('waterMeter.低压状态')"
        width="120"
        show-overflow-tooltip
        v-if="visibleList.includes(20)">
        </el-table-column>
        <el-table-column
        prop="powerDown"
        :label="$t('waterMeter.掉电状态')"
        width="120"
        show-overflow-tooltip
        v-if="visibleList.includes(21)">
        </el-table-column>
        <el-table-column
        prop="dingShiDongJieJianGe"
        :label="$t('waterMeter.定时冻结间隔')"
        width="150"
        show-overflow-tooltip
        v-if="visibleList.includes(22)">
        </el-table-column>
        <el-table-column
        prop="shiBaiShangChuanCiShu"
        :label="$t('waterMeter.上传失败次数')"
        width="150"
        show-overflow-tooltip
        v-if="visibleList.includes(23)">
        </el-table-column>
        <el-table-column
        prop="shuiWenF"
        :label="$t('waterMeter.水温')"
        width="120"
        show-overflow-tooltip
        v-if="visibleList.includes(24)">
        </el-table-column>
        <el-table-column
      fixed="right"
      :label="$t('waterMeter.操作')"
      :width="$i18n.locale === 'en' ? 400 : 220">
      <template slot-scope="scope">
        <div style="display: flex; flex-wrap: wrap;">
          <el-button
            type="text"
            size="small"
            style="margin: 5px 5px"
            @click="cxunbtn(scope.row)">
            {{ $t('waterMeter.设备进程') }}
          </el-button>
          <el-button
            type="text"
            size="small"
            style="margin: 5px 5px"
            @click="YYQXbtn(scope.row)">
            {{ $t('waterMeter.用水曲线') }}
          </el-button>
          <el-button
            type="text"
            size="small"
            style="margin: 5px 5px"
            @click="history(scope.row)">
            {{ $t('waterMeter.历史记录') }}
          </el-button>
          <!-- <el-button
            type="text"
            size="small"
            style="margin: 5px 5px"
            @click="TableDailyUsage(scope.row)">
            {{ $t('waterMeter.设备日用量') }}
          </el-button> -->
          <el-button
            type="text"
            size="small"
            style="margin: 5px 5px"
            @click="TablecodeBtn(scope.row)">
            {{ $t('waterMeter.录入表码') }}
          </el-button>
        </div>
      </template>
    </el-table-column>
    </el-table>
    <div class="table_bock">
      <div class="trends_oprt_wrap">
        <el-popover placement="top-start" width="600" trigger="click">
          <div class="trends_btn_wrap">
            <el-checkbox-group v-model="visibleList" size="small">
              <el-checkbox
                v-for="(col, index) in columnList"
                :key="index"
                :label="index"
                border
                >{{ col.label }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
          <el-button slot="reference" size="small">隐藏/显示列</el-button>
        </el-popover>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="famlis.pagenum"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="famlis.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
      </el-card>
    </div>
    <!-- 内容区域移动端 -->
    <div class="moveab">
      <el-card>
        <el-table
        ref="multipleTable"
        :data="parData"
        tooltip-effect="dark"
        style="width: 100%"
        height='300'
        highlight-current-row
        @selection-change="handleSelectionChange"
        :row-class-name="rowStyle">
        <el-table-column
        type="selection"
        width="50">
        </el-table-column>
        <el-table-column
        prop="meter_id"
        :label="$t('waterMeter.水表编号')"
        width=""
        :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
        prop="username"
        :label="$t('waterMeter.用户名')"
        width=""
        :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
      fixed="right"
      :label="$t('waterMeter.操作')"
      width="90">
      <template slot-scope="scope">
        <el-dropdown trigger="click" @command="(cmd) => handleMobileRowCommand(cmd, scope.row)">
          <el-button type="primary" size="mini" class="mobile-op-btn">
            {{ $t('waterMeter.操作') }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="progress">{{ $t('waterMeter.设备进程') }}</el-dropdown-item>
            <el-dropdown-item command="curve">{{ $t('waterMeter.用水曲线') }}</el-dropdown-item>
            <el-dropdown-item command="history">{{ $t('waterMeter.历史记录') }}</el-dropdown-item>
            <!-- <el-dropdown-item command="daily">{{ $t('waterMeter.设备日用量') }}</el-dropdown-item> -->
            <el-dropdown-item command="code">{{ $t('waterMeter.录入表码') }}</el-dropdown-item>
            <el-dropdown-item command="detail">详情</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-table-column>
    </el-table>
    <div class="table_bock">
      <el-pagination
        class="acc-pagination"
        small
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="famlis.pagenum"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="famlis.pagesize"
        layout="prev, pager, next"
        :pager-count="5"
        :total="total">
      </el-pagination>
    </div>
      </el-card>
    </div>
    <!-- 手机端表格行详情 -->
    <div class="locationOpenvalve">
      <el-dialog title="详情" :visible.sync="mobileDetailVisible">
        <div class="mobile-detail-wrap">
          <div class="mobile-detail-row" v-for="item in getMobileDetailEntries()" :key="item.key">
            <span class="k">{{ item.label }}：</span>
            <span class="v">{{ item.value }}</span>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="mobileDetailVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
  <!-- 开阀弹框-->
  <div class="locationOpenvalve">
  <el-dialog :title="$t('waterMeter.开阀设备')" :visible.sync="tianjiaVisible">
  <el-form>
    <el-form-item>
      <span>{{ $t('waterMeter.当前勾选') }}: {{ValveControl.lengthid}} {{ $t('waterMeter.台设备') }}</span>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="ValveControl.regional_issued"  :disabled="commandBan">为当前({{ positionName }})<span style="color: red;">{{regionName}}</span>下发命令</el-checkbox>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button plain size="medium" @click="OpenCancel">{{ $t('waterMeter.取消') }}</el-button>
    <el-button type="success" size="medium" @click="OpenSubmit">{{ $t('waterMeter.提交') }}</el-button>
  </div>
</el-dialog>
  </div>
  <!-- 关阀弹框-->
  <div class="locationOpenvalve">
  <el-dialog :title="$t('waterMeter.关阀')" :visible.sync="CloseVisible">
  <el-form>
    <el-form-item>
      <span>{{ $t('waterMeter.当前勾选') }}: {{ValveControl.lengthid}} {{ $t('waterMeter.台设备') }}</span>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="ValveControl.regional_issued"  :disabled="commandBan">为当前({{ positionName }})<span style="color: red;">{{regionName}}</span>下发命令</el-checkbox>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button plain size="medium" @click="OpenCancel">{{ $t('waterMeter.取消') }}</el-button>
    <el-button type="success" size="medium" @click="OpenSubmit">{{ $t('waterMeter.提交') }}</el-button>
  </div>
</el-dialog>
  </div>
  <!-- 报警关阀弹框-->
  <div class="locationOpenvalve">
  <el-dialog :title="$t('waterMeter.报警关阀')" :visible.sync="callCloseVisible">
  <el-form>
    <el-form-item>
      <span>{{ $t('waterMeter.当前勾选') }}: {{ValveControl.lengthid}} {{ $t('waterMeter.台设备') }}</span>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="ValveControl.regional_issued"  :disabled="commandBan">为当前({{ positionName }})<span style="color: red;">{{regionName}}</span>下发命令</el-checkbox>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button plain size="medium" @click="OpenCancel">{{ $t('waterMeter.取消') }}</el-button>
    <el-button type="success" size="medium" @click="OpenSubmit">{{ $t('waterMeter.提交') }}</el-button>
  </div>
</el-dialog>
  </div>
  <!-- 阀门测试弹框-->
  <div class="locationOpenvalve">
  <el-dialog :title="$t('waterMeter.阀门测试')" :visible.sync="TestCloseVisible">
  <el-form>
    <el-form-item>
      <span>{{ $t('waterMeter.当前勾选') }}: {{ValveControl.lengthid}} {{ $t('waterMeter.台设备') }}</span>
    </el-form-item>
    <el-form-item>
      <el-checkbox v-model="ValveControl.regional_issued"  :disabled="commandBan">为当前({{ positionName }})<span style="color: red;">{{regionName}}</span>下发命令</el-checkbox>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button plain size="medium" @click="OpenCancel">{{ $t('waterMeter.取消') }}</el-button>
    <el-button type="success" size="medium" @click="OpenSubmit">{{ $t('waterMeter.提交') }}</el-button>
  </div>
</el-dialog>
  </div>
  <!-- 查询设置进程 -->
  <!-- 编辑的弹框 -->
  <div class="cyclKai">
  <el-dialog custom-class="wm-process-dialog" :title="('设备进程')" :visible.sync="dialgVsibles">
    <div class="wwoop"><span>{{$t('waterMeter.设备编号')}}: {{this.ccnn}}</span></div>
     <el-table
    :data="bansdata"
    ref="historyTable"
    border
    height='400'
    :header-cell-style="{'text-align':'center'}"
    :cell-style="{'text-align':'center'}"
    style="width: 100%">
    <el-table-column
      v-if="!isMobile"
      type="index"
      :label="$t('waterMeter.序号')"
      width="70">
    </el-table-column>
    <el-table-column
      prop="meter_id"
      :label="$t('waterMeter.水表编号')" :width="isMobile ? 'auto' : 171">
    </el-table-column>
    <el-table-column
      prop="command_type"
      :label="$t('waterMeter.操作内容')"
      :width="isMobile ? 'auto' : 120">
    </el-table-column>
    <el-table-column
      prop="status"
      :label="$t('waterMeter.操作结果')" :width="isMobile ? 'auto' : 100">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="create_time"
      :label="$t('waterMeter.创建时间')">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="send_time"
      :label="$t('waterMeter.发送时间')">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="run_time"
      :label="$t('waterMeter.完成时间')">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="result"
      :label="$t('waterMeter.响应结果')">
    </el-table-column>
    <el-table-column
      v-if="isMobile"
      :label="$t('waterMeter.操作')"
      :width="isMobile ? 'auto' : 100">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="openSubTableDetail('process', scope.row)">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      class="dialog-acc-pagination"
      :small="isMobile"
      :layout="dialogPaginationLayout"
      :pager-count="isMobile ? 5 : 7"
      @size-change="processSizeChange"
      @current-change="processCurrentChange"
      :current-page="cuanss.pagenum"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="cuanss.pagesize"
      :total="cuansstotal">
    </el-pagination>
    </el-dialog>
  </div>
    <!-- 编辑的弹框 定点上传 -->
    <div class="cyclKai">
  <el-dialog custom-class="wm-btn-area-dialog" :title="$t('waterMeter.定点上传')" :visible.sync="fixedVsibles">
    <div class="Periodic">
    <div>{{ $t('waterMeter.当前勾选') }}: {{ValveControl.lengthid}} {{ $t('waterMeter.台设备') }}</div>
    <el-checkbox v-model="fixesiso.regional_issued" :disabled="commandBan">为当前({{ positionName }})<span style="color: red;">{{regionName}}</span>下发命令</el-checkbox>
    </div>
    <div class="dingdianfas">
      <span>{{ $t('waterMeter.每') }}</span><span class="wm-nbsp-desktop" aria-hidden="true"></span>
      <el-select v-model="month" popper-class="mobile-select-popper" :placeholder="$t('waterMeter.月') + '/' + $t('waterMeter.日')" @change="monthChange">
        <el-option
        v-for="item in montopns"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select><span class="wm-nbsp-desktop" aria-hidden="true"></span>
    <div class="y1" v-show="isyue">
      <span>{{ $t('waterMeter.的') }}</span><span class="wm-nbsp-desktop" aria-hidden="true"></span>
      <el-select v-model="dayval" popper-class="mobile-select-popper" multiple :multiple-limit='4' @change="dayChange" :placeholder="$t('waterMeter.日')">
        <el-option
        v-for="item in dayopns"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select><span class="wm-nbsp-desktop" aria-hidden="true"></span>
    <span>{{ $t('waterMeter.的') }}</span><span class="wm-nbsp-desktop" aria-hidden="true"></span>
      <el-select v-model="hourval" popper-class="mobile-select-popper" @change="hourChange" :placeholder="$t('waterMeter.时')">
        <el-option
        v-for="item in Houropns"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select><span class="wm-nbsp-desktop" aria-hidden="true"></span>
    <span>{{ $t('waterMeter.上传') }}</span>
    </div>
    <div class="y2" v-show="isday">
      <span>{{ $t('waterMeter.的') }}</span><span class="wm-nbsp-desktop" aria-hidden="true"></span>
      <el-select v-model="hourfsis" popper-class="mobile-select-popper" multiple :multiple-limit='4' @change="hoursChange" :placeholder="$t('waterMeter.时')" size='small' class="wm-dingdian-hour-select">
        <el-option
        v-for="item in hoursopns"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select><span class="wm-nbsp-desktop" aria-hidden="true"></span>
    <span>{{ $t('waterMeter.上传') }}</span>
    </div>
    </div>
    <div class="zhuos"> 注: 如果后面不选择的话就取消定点上传功能 </div>
    <div slot="footer" class="dialog-footer">
    <el-button plain size="medium" @click="faixvals">{{ $t('waterMeter.取消') }}</el-button>
    <el-button type="success" size="medium" @click="faixbtn">{{ $t('waterMeter.提交') }}</el-button>
  </div>
    </el-dialog>
  </div>
    <!-- 编辑的弹框 周期上传-->
    <div class="cycle">
  <el-dialog custom-class="wm-btn-area-dialog" :title="$t('waterMeter.周期上传')" :visible.sync="zqiVsibles">
    <div class="Periodic">
      <span>{{ $t('waterMeter.当前勾选') }}: {{ValveControl.lengthid}} {{ $t('waterMeter.台设备') }}</span>
      <el-checkbox v-model="fixesiso.regional_issued" :disabled="commandBan">为当前({{ positionName }})<span style="color: red;">{{regionName}}</span>下发命令</el-checkbox>
    </div>
    <div class="time">
      <span>{{ $t('waterMeter.上传时间') }}：</span>
      <el-time-picker
        is-range
        @change="chanvalu"
        v-model="homemo"
        format="HH:mm"
        value-format="HH:mm"
        :range-separator="$t('waterMeter.至')"
        :start-placeholder="$t('waterMeter.开始时间')"
        :end-placeholder="$t('waterMeter.结束时间')"
        :placeholder="$t('waterMeter.选择时间范围')"
      >
  </el-time-picker>
  <el-button @click="zqibtn">{{ $t('waterMeter.提交') }}</el-button>
    </div>
    <div class="wm-interval-row">
      <span>{{ $t('waterMeter.上传间隔') }}：</span>
      <el-input-number v-model="interval.params.d2" controls-position="right" @change="handleChange" :min="10" :max="65536"></el-input-number>
      <el-button @click="jiangebtn">{{ $t('waterMeter.提交') }}</el-button>
    </div>
    </el-dialog>
  </div>
    <!-- 编辑的弹框 日冻结数据-->
    <div class="cycle">
  <el-dialog custom-class="wm-btn-area-dialog" :title="$t('waterMeter.日冻结数据')" :visible.sync="rdjVsibles">
    <div class="block">
    <el-date-picker
      v-model="rdais.day_date"
      type="date"
      @change='rekois'
      :placeholder="$t('waterMeter.选择日期')">
    </el-date-picker>
    <el-button @click="fasidata">{{ $t('waterMeter.查询') }}</el-button>
  </div>
  <div class="rdojie">
      <el-card>
        <el-table
        ref="multipleTable"
        :data="redatas"
        tooltip-effect="dark"
        style="width: 100%"
        height='300'
        size=mini>
        <el-table-column
        prop="leiJiLiuLiangZhengXiangF"
        :label="$t('waterMeter.正向累计流量')"
        width="100">
        </el-table-column>
        <el-table-column
        prop="lastDongJieShiJian"
        :label="$t('waterMeter.冻结时间')"
        width="150">
        </el-table-column>
        <el-table-column
        prop="meterId"
        :label="$t('waterMeter.水表编号')"
        width="140">
        </el-table-column>
        <el-table-column
        prop="lastUploadDate"
        :label="$t('waterMeter.上传日期')"
        width="150"
        :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
        prop="leiJiLiuLiangF"
        :label="$t('waterMeter.净累计流量')"
        width="140"
        :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
        prop="leiJiLiuLiangFanXiangF"
        :label="$t('waterMeter.反向累计流量')"
        width="140">
        </el-table-column>
    </el-table>
      </el-card>
    </div>
    </el-dialog>
  </div>
    <!-- 编辑的弹框 月冻结数据-->
    <div class="cycle">
  <el-dialog custom-class="wm-btn-area-dialog" :title="$t('waterMeter.月冻结数据')" :visible.sync="yueVsibles">
    <div class="block">
    <el-date-picker
      type="month"
      v-model="rdais.month_date"
      @change='er'
      :placeholder="$t('waterMeter.选择月')">
    </el-date-picker>
    <el-button @click="residata">{{ $t('waterMeter.查询') }}</el-button>
  </div>
  <div class="rdojie">
      <el-card>
        <el-table
        ref="multipleTable"
        :data="yuedatas"
        tooltip-effect="dark"
        style="width: 100%"
        height='300'
        size=mini>
        <el-table-column
        prop="meterId"
        :label="$t('waterMeter.水表编号')"
        width="140">
        </el-table-column>
        <el-table-column
        prop="lastDongJieShiJian"
        :label="$t('waterMeter.冻结时间')"
        width="150">
        </el-table-column>
        <el-table-column
        prop="leiJiLiuLiangF"
        :label="$t('waterMeter.净累计流量')"
        width="140"
        :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
        prop="leiJiLiuLiangZhengXiangF"
        :label="$t('waterMeter.正向累计流量')"
        width="100">
        </el-table-column>
        <el-table-column
        prop="leiJiLiuLiangFanXiangF"
        :label="$t('waterMeter.反向累计流量')"
        width="140">
        </el-table-column>
        <el-table-column
        prop="lastUploadDate"
        :label="$t('waterMeter.上传日期')"
        width="150"
        :show-overflow-tooltip="true">
        </el-table-column>
    </el-table>
      </el-card>
    </div>
    </el-dialog>
  </div>
    <!-- 编辑的弹框 日冻结数据-->
    <div class="cycle">
  <el-dialog custom-class="wm-btn-area-dialog" :title="$t('waterMeter.日冻结参数')" :visible.sync="DailVsibles">
    <div class="Periodic">
    <span>{{ $t('waterMeter.当前勾选') }}: {{ValveControl.lengthid}} {{ $t('waterMeter.台设备') }}</span>
    <el-checkbox v-model="fixesiso.regional_issued" :disabled="commandBan">为当前({{ positionName }})<span style="color: red;">{{regionName}}</span>下发命令</el-checkbox>
    </div>
    <div class="block">
      <span>{{ $t('waterMeter.日冻结时间') }}：</span>
    <el-time-picker
    v-model="Dailyparameters"
    format="HH:mm"
    value-format="HH:mm"
    @change='Dailymeters'
    size="medium"
    :placeholder="$t('waterMeter.选择时间')">
  </el-time-picker>
    <el-button @click="Dailyparametersbtn" size="medium">{{ $t('waterMeter.提交') }}</el-button>
  </div>
    </el-dialog>
  </div>
    <!-- 编辑的弹框 月冻结数据-->
    <div class="cycle">
  <el-dialog custom-class="wm-btn-area-dialog" :title="$t('waterMeter.月冻结参数')" :visible.sync="MonthlyVsibles">
    <div class="Periodic">
    <span>{{ $t('waterMeter.当前勾选') }}: {{ValveControl.lengthid}} {{ $t('waterMeter.台设备') }}</span>
    <el-checkbox v-model="fixesiso.regional_issued" :disabled="commandBan">为当前({{ positionName }})<span style="color: red;">{{regionName}}</span>下发命令</el-checkbox>
    </div>
    <div class="block">
    <span>{{ $t('waterMeter.月冻结时间') }}：</span>
    <el-select v-model="months" popper-class="mobile-select-popper" @change="DailyChange" :placeholder="$t('waterMeter.日')" size='small'>
        <el-option
        v-for="item in dayopns"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select><span class="wm-nbsp-desktop" aria-hidden="true"></span>
    <span>{{ $t('waterMeter.的') }}</span><span class="wm-nbsp-desktop" aria-hidden="true"></span>
      <el-select v-model="Hours" popper-class="mobile-select-popper" @change="HourChange" :placeholder="$t('waterMeter.时')" size='small'>
        <el-option
        v-for="item in Houropns"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select><span class="wm-nbsp-desktop" aria-hidden="true"></span>
    <el-button @click="Monthlyfreeze" size="medium">{{ $t('waterMeter.提交') }}</el-button>
  </div>
    </el-dialog>
  </div>
    <!-- 编辑的弹框 历史纪录-->
    <div class="cyclKai">
  <el-dialog custom-class="wm-history-dialog" :title="$t('waterMeter.历史记录')" :visible.sync="historyVsibles">
    <div class="aaaaaaaaaa">
    <el-table :data="tableData" ref="historyTable" size=mini height='300' tooltip-effect="dark" highlight-current-row :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" element-loading-text="拼命加载中">
    <el-table-column v-if="!isMobile" type="index" width="50" :label="$t('waterMeter.序号')" />
    <el-table-column property="meterId" :label="$t('waterMeter.水表编号')" :width="isMobile ? 'auto' : 171" />
    <el-table-column v-if="!isMobile" property="sumFlow" :label="$t('waterMeter.累计总用量')" width="100" :show-overflow-tooltip="true" />
    <el-table-column v-if="!isMobile" property="unit" :label="$t('waterMeter.单元')" width="100" />
    <el-table-column property="plotReceiveTime" :label="$t('waterMeter.抄表时间')" :width="isMobile ? 'auto' : 171"  />
    <el-table-column v-if="!isMobile" property="netAccumulation" :label="$t('waterMeter.净累计流量')" width="100" />
    <el-table-column v-if="!isMobile" property="reverseAccumulation" :label="$t('waterMeter.反向累计流量')" width="100" />
    <el-table-column v-if="!isMobile" property="atAccumulation" :label="$t('waterMeter.瞬时流量')" width="100" />
    <el-table-column v-if="!isMobile" property="batteryVoltage" :label="$t('waterMeter.电池电压')" width="100" />
    <el-table-column v-if="!isMobile" property="signallntensity" :label="$t('waterMeter.信号强度')" width="100" />
    <el-table-column
        v-if="!isMobile"
        prop="shiBaiShangChuanCiShu"
        :label="$t('waterMeter.上传失败次数')"
        show-overflow-tooltip>
        </el-table-column>
        <el-table-column
        v-if="!isMobile"
        prop="dingShiDongJieJianGe"
        :label="$t('waterMeter.定时冻结间隔')"
        show-overflow-tooltip>
        </el-table-column>
        <el-table-column
        v-if="!isMobile"
        prop="yaLiF"
        :label="$t('waterMeter.压力')"
        show-overflow-tooltip>
        </el-table-column>
        <el-table-column
        v-if="!isMobile"
        prop="shuiWenF"
        :label="$t('waterMeter.水温')"
        show-overflow-tooltip>
        </el-table-column>
    <el-table-column v-if="!isMobile" property="powerDown" :label="$t('waterMeter.掉电状态')" width="100" />
    <el-table-column v-if="!isMobile" property="powerLow" :label="$t('waterMeter.低压状态')" width="100" />
    <el-table-column v-if="!isMobile" property="magneticAttack" :label="$t('waterMeter.磁攻击')" width="100" />
    <el-table-column v-if="!isMobile" property="valveStatus" :label="$t('waterMeter.阀门状态')" width="172" />
    <el-table-column v-if="!isMobile" property="zhuangTaiChaiXieZhuangTai" :label="$t('waterMeter.拆卸状态')" />
    <el-table-column
        v-if="!isMobile"
        prop="zhuangTaiLouShui"
        :label="$t('waterMeter.漏水报警')"
        show-overflow-tooltip>
        </el-table-column>
        <el-table-column
        v-if="!isMobile"
        prop="zhuangTaiFanXiangJiLiang"
        :label="$t('waterMeter.反向计量')"
        show-overflow-tooltip>
        </el-table-column>
        <el-table-column
        v-if="!isMobile"
        prop="zhuangTaiLiuLiangChaoShangXian"
        :label="$t('waterMeter.流量超限')"
        show-overflow-tooltip>
        </el-table-column>
        <el-table-column
        v-if="!isMobile"
        prop="zhuangTaiYeweibaojing"
        :label="$t('waterMeter.液位报警')"
        show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="isMobile"
          :label="$t('waterMeter.操作')"
          :width="isMobile ? 'auto' : 100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openSubTableDetail('history', scope.row)">详情</el-button>
          </template>
        </el-table-column>
    </el-table>
    <el-pagination
      class="dialog-acc-pagination"
      :small="isMobile"
      :layout="dialogPaginationLayout"
      :pager-count="isMobile ? 5 : 7"
      @size-change="watefamlsSizeChange"
      @current-change="watefamlsCurrentChange"
      :current-page="watefamls.pagenum"
      :page-sizes="[10, 20, 40, 60, 70]"
      :page-size="watefamls.pagesize"
      :total="watefamlstotal">
    </el-pagination>
    </div>
    </el-dialog>
  </div>
    <!-- 暂无数据 -->
    <!-- <div class="wuju" v-show="zanwu">{{ $t('waterMeter.暂无数据') }}</div> -->
    <!-- 用水曲线 -->
     <div class="yyqxcals">
  <el-dialog custom-class="wm-yyqx-dialog" :title="$t('waterMeter.用水曲线')" :visible.sync="YYQXVsibles" width="70%" :before-close="handleClose" >
    <div class="block wm-yyqx-toolbar">
    <el-date-picker
      v-model="YYQXdes.search_time"
      type="date"
      value-format="yyyy-MM-dd"
      :placeholder="$t('waterMeter.选择日期')">
    </el-date-picker>
    <el-button @click="YYCXbtn">{{ $t('waterMeter.查询') }}</el-button>
  </div>
  <div class="rdojie wm-yyqx-chart" v-show="yycxshow">
      <el-card>
        <EchaSDLL :message="timeheflow" :compact="isMobile"/>
      </el-card>
      <el-card>
        <TrafficPressureEchaets :message="timeheflow" :compact="isMobile"/>
      </el-card>
    </div>
    </el-dialog>
  </div>
   <!-- 录入表码 -->
   <div class="Number-table-codes">
  <el-dialog
    custom-class="wm-table-code-dialog"
    :title="$t('waterMeter.录入表码')"
    :visible.sync="TableCold"
    @closed="handleClosed"
    @opened="onTableCodeDialogOpened">
    <div class="wm-table-code-body">
      <span class="wm-table-code-label">{{ $t('waterMeter.表码数') }}:</span>
      <el-input ref="tableCodeInput" class="wm-table-code-input" v-model.trim="tabcode.flow" clearable />
    </div>
    <div slot="footer" class="dialog-footer">
    <el-button style="background-color: #744dfe; color: #fff;" size="small" @click="GinBaous">{{ $t('waterMeter.保存') }}</el-button>
  </div>
    </el-dialog>
  </div>
  <!-- 查询设备日用量 -->
  <div class="yyqxcals">
  <el-dialog
    custom-class="wm-daily-usage-dialog"
    :title="$t('QueryDailyUsage.设备日用量')"
    :visible.sync="QueryDailyUsage"
    @closed="handleClosed">
    <div class="wm-daily-usage-toolbar">
      <el-date-picker
      v-model="dailyTime"
      type="daterange"
      size="medium"
      value-format="yyyy-MM-dd"
      :popper-class="isMobile ? 'wm-daily-range-popper' : ''"
      :unlink-panels="isMobile"
      :range-separator="$t('QueryDailyUsage.至')"
      :start-placeholder="$t('QueryDailyUsage.开始日期')"
      :end-placeholder="$t('QueryDailyUsage.结束日期')">
    </el-date-picker>
    <el-button @click="QueryDailyUsagebtn">{{ $t('waterMeter.查询') }}</el-button>
    <el-button @click="Resetbtn">{{ $t('QueryDailyUsage.重置') }}</el-button>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-table
    :data="TableDailyUsageData"
    ref="historyTable"
    height="300"
    border
    style="width: 100%">
    <el-table-column v-if="!isMobile" type="index"/>
    <el-table-column
      prop="meter_id"
      :label="$t('QueryDailyUsage.水表编号')"
      :width="isMobile ? 'auto' : 180">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="settlement_time"
      :label="$t('QueryDailyUsage.统计日期')"
      width="180">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="flow"
      :label="$t('QueryDailyUsage.当日用量')"
      width="180">
    </el-table-column>
    <el-table-column
      v-if="!isMobile"
      prop="total_flow"
      :label="$t('QueryDailyUsage.当前表码数')"
      width="180">
    </el-table-column>
    <el-table-column property="finished" :label="$t('QueryDailyUsage.是否结算')"  :width="isMobile ? 'auto' : 180" :show-overflow-tooltip="true">
      <template slot-scope="scope">
        <span v-if="scope.row.finished === true || scope.row.finished === 'true' || scope.row.finished === 0">{{ $t('QueryDailyUsage.是') }}</span>
        <span v-else>{{ $t('QueryDailyUsage.否') }}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="isMobile"
      :label="$t('waterMeter.操作')"
      :width="isMobile ? 'auto' : 100">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="openSubTableDetail('daily', scope.row)">详情</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      class="dialog-acc-pagination"
      :small="isMobile"
      :layout="dialogPaginationLayout"
      :pager-count="isMobile ? 5 : 7"
      @size-change="QueryDailyUsageSizeChange"
      @current-change="QueryDailyUsageCurrentChange"
      :current-page="TableDailyUsageparameter.pagenum"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="TableDailyUsageparameter.pagesize"
      :total="DailyUsagetotal">
    </el-pagination>
  </div>
    </el-dialog>
  </div>
  <div class="locationOpenvalve">
    <el-dialog title="详情" :visible.sync="subTableDetailVisible">
      <div class="mobile-detail-wrap">
        <div class="mobile-detail-row" v-for="item in getSubTableDetailEntries()" :key="item.key">
          <span class="k">{{ item.label }}：</span>
          <span class="v">{{ item.value }}</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="subTableDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>
<script>
import { dataConversionUtil } from '@/utils/data2Excel'
import EchaSDLL from './echartsSDLL.vue'
import TrafficPressureEchaets from './trafficPressureEchaets.vue'
// 手机端详情弹框字段：与 PC 表格列（prop）顺序一致，仅展示这些项
const MOBILE_DETAIL_FIELD_CONFIG = [
  { key: 'pay_id', t: 'waterMeter.缴费编号' },
  { key: 'meter_id', t: 'waterMeter.水表编号' },
  { key: 'username', t: 'waterMeter.用户名' },
  { key: 'address', t: 'waterMeter.位置' },
  { key: 'balance', t: 'waterMeter.余额' },
  { key: 'sumFlow', t: 'waterMeter.正向累计流量' },
  { key: 'netAccumulation', t: 'waterMeter.净累计流量' },
  { key: 'reverseAccumulation', t: 'waterMeter.反向累计流量' },
  { key: 'atAccumulation', t: 'waterMeter.瞬时流量' },
  { key: 'plotReceiveTime', t: 'waterMeter.最新上报时间' },
  { key: 'yaLiF', t: 'waterMeter.压力' },
  { key: 'valveStatus', t: 'waterMeter.阀门状态' },
  { key: 'signallntensity', t: 'waterMeter.信号强度' },
  { key: 'batteryVoltage', t: 'waterMeter.电池电压' },
  { key: 'zhuangTaiLouShui', t: 'waterMeter.漏水报警' },
  { key: 'zhuangTaiYeweibaojing', t: 'waterMeter.液位报警' },
  { key: 'zhuangTaiFanXiangJiLiang', t: 'waterMeter.反向计量' },
  { key: 'zhuangTaiLiuLiangChaoShangXian', t: 'waterMeter.流量超限' },
  { key: 'magneticAttack', t: 'waterMeter.磁攻击' },
  { key: 'zhuangTaiChaiXieZhuangTai', t: 'waterMeter.拆卸状态' },
  { key: 'powerLow', t: 'waterMeter.低压状态' },
  { key: 'powerDown', t: 'waterMeter.掉电状态' },
  { key: 'dingShiDongJieJianGe', t: 'waterMeter.定时冻结间隔' },
  { key: 'shiBaiShangChuanCiShu', t: 'waterMeter.上传失败次数' },
  { key: 'shuiWenF', t: 'waterMeter.水温' }
]
const MOBILE_HISTORY_DETAIL_FIELD_CONFIG = [
  { key: 'meterId', t: 'waterMeter.水表编号' },
  { key: 'sumFlow', t: 'waterMeter.累计总用量' },
  { key: 'unit', t: 'waterMeter.单元' },
  { key: 'plotReceiveTime', t: 'waterMeter.抄表时间' },
  { key: 'netAccumulation', t: 'waterMeter.净累计流量' },
  { key: 'reverseAccumulation', t: 'waterMeter.反向累计流量' },
  { key: 'atAccumulation', t: 'waterMeter.瞬时流量' },
  { key: 'batteryVoltage', t: 'waterMeter.电池电压' },
  { key: 'signallntensity', t: 'waterMeter.信号强度' },
  { key: 'shiBaiShangChuanCiShu', t: 'waterMeter.上传失败次数' },
  { key: 'dingShiDongJieJianGe', t: 'waterMeter.定时冻结间隔' },
  { key: 'yaLiF', t: 'waterMeter.压力' },
  { key: 'shuiWenF', t: 'waterMeter.水温' },
  { key: 'powerDown', t: 'waterMeter.掉电状态' },
  { key: 'powerLow', t: 'waterMeter.低压状态' },
  { key: 'magneticAttack', t: 'waterMeter.磁攻击' },
  { key: 'valveStatus', t: 'waterMeter.阀门状态' },
  { key: 'zhuangTaiChaiXieZhuangTai', t: 'waterMeter.拆卸状态' },
  { key: 'zhuangTaiLouShui', t: 'waterMeter.漏水报警' },
  { key: 'zhuangTaiFanXiangJiLiang', t: 'waterMeter.反向计量' },
  { key: 'zhuangTaiLiuLiangChaoShangXian', t: 'waterMeter.流量超限' },
  { key: 'zhuangTaiYeweibaojing', t: 'waterMeter.液位报警' }
]
const MOBILE_PROCESS_DETAIL_FIELD_CONFIG = [
  { key: 'meter_id', t: 'waterMeter.水表编号' },
  { key: 'command_type', t: 'waterMeter.操作内容' },
  { key: 'status', t: 'waterMeter.操作结果' },
  { key: 'create_time', t: 'waterMeter.创建时间' },
  { key: 'send_time', t: 'waterMeter.发送时间' },
  { key: 'run_time', t: 'waterMeter.完成时间' },
  { key: 'result', t: 'waterMeter.响应结果' }
]
const MOBILE_DAILY_DETAIL_FIELD_CONFIG = [
  { key: 'meter_id', t: 'QueryDailyUsage.水表编号' },
  { key: 'settlement_time', t: 'QueryDailyUsage.统计日期' },
  { key: 'flow', t: 'QueryDailyUsage.当日用量' },
  { key: 'total_flow', t: 'QueryDailyUsage.当前表码数' },
  { key: 'finished', t: 'QueryDailyUsage.是否结算' }
]

export default {
  components: {
    EchaSDLL,
    TrafficPressureEchaets
  },
  inject: ['reload'],
  data () {
    return {
      commandBan: false, //区域下发是否能选择框
      regionName: '', // 区域名称
      positionName: '', // 区域位置
      hideColumnIndexs: [], // 示例隐藏列的索引
      // 可见列索引，默认全部显示
      visibleList: [],
      // 手机端下拉选项触摸兜底（解决首次点击仅高亮）
      _mobileSelectTouchEndHandler: null,
      /** 视口 ≤768px，弹框内分页与交款退款手机端一致 */
      isMobile: false,
      // 手机端表格详情
      mobileDetailVisible: false,
      mobileDetailRow: {},
      subTableDetailVisible: false,
      subTableDetailRow: {},
      subTableDetailType: '',
      columnList: [
        // 表格所有列名称数据列表
        { label: '缴费编号', defaultVisible: true },
        { label: '水表编号', defaultVisible: true },
        { label: '用户名', defaultVisible: true },
        { label: '位置', defaultVisible: true },
        { label: '余额', defaultVisible: true },
        { label: '正向累计流量', defaultVisible: true },
        { label: '净累计流量', defaultVisible: true },
        { label: '反向累计流量', defaultVisible: true },
        { label: '瞬时流量', defaultVisible: true },
        { label: '最新上报时间', defaultVisible: true },
        { label: '压力', defaultVisible: true },
        { label: '阀门状态', defaultVisible: true },
        { label: '信号强度', defaultVisible: true },
        { label: '电池电压', defaultVisible: true },
        { label: '漏水报警', defaultVisible: true },
        { label: '液位报警', defaultVisible: true },
        { label: '反向计量', defaultVisible: true },
        { label: '流量超限', defaultVisible: true },
        { label: '磁攻击', defaultVisible: true },
        { label: '拆卸状态', defaultVisible: true },
        { label: '低压状态', defaultVisible: true },
        { label: '掉电状态', defaultVisible: true },
        { label: '定时冻结间隔', defaultVisible: true },
        { label: '上传失败次数', defaultVisible: true },
        { label: '水温', defaultVisible: true }

      ],
      TableCold: false, // 录入表码弹框
      tabcode: {
        meter_id: null,
        token: null,
        flow: ''
      },
      // 查询日用水参数
      TableDailyUsageparameter: {
        token: null,
        meter_id: null,
        pagenum: 1,
        pagesize: 20,
        start_date: null,
        end_date: null
      },
      dailyTime: [], // 查询日用水时间
      TableDailyUsageData: [], // 查询日用水数据
      QueryDailyUsage: false, // 查询日用水弹框
      DailyUsagetotal: null, // 日用水总条数
      // 用水曲线
      YYQXVsibles: false, // 用水曲线弹框
      yycxshow: false, // 用水曲线显示
      timeheflow: {}, // 用水曲线数据
      aioid: null, // 用水曲线id
      YYQXdes: { // 用水曲线参数
        token: null,
        meter_id: null,
        search_time: null
      },
      // table数据
      tableData: [{
        meterId: null,
        sumFlow: null,
        unit: null,
        insertTime: null,
        valveStatus: null
      }],
      historyVsibles: false,
      months: null,
      Hours: null,
      Dailyparameters: null,
      valuess1: null,
      MonthlyVsibles: false,
      DailVsibles: false,
      homemo: null,
      value1: null,
      yueVsibles: null,
      rdj: null,
      rdjVsibles: false,
      hms: [new Date(2022, 9, 10, 8, 40), new Date(2022, 9, 10, 9, 40)],
      num: 10,
      zqiVsibles: false,
      isday: false,
      isyue: false,
      bansdata: [],
      fixedVsibles: false,
      dialgVsibles: false,
      TestCloseVisible: false,
      callCloseVisible: false,
      tianjiaVisible: false,
      CloseVisible: false,
      // 暂无数据
      zanwu: false,
      // 月冻结数据
      yuedatas: [],
      redatas: [],
      // 定点上传提交
      fixesiso: {
        token: null,
        optionId: 5,
        regional_issued: false,
        meter_id_list: [],
        community_id: null,
        building_id: null,
        unit_id: null,
        room_id: null,
        params: {
          d1: null,
          d2: ''
        }
      },
      fansd: [],
      huoers: null,
      // 周期上传间隔
      interval: {
        token: null,
        optionId: 5,
        regional_issued: false,
        meter_id_list: [],
        community_id: null,
        building_id: null,
        unit_id: null,
        room_id: null,
        params: {
          d1: null,
          d2: null
        }
      },
      // 定点上传月
      month: '',
      montopns: [{
        id: 1,
        name: '月'
      }, {
        id: 2,
        name: '日'
      }],
      // 定点上传日
      dayval: '',
      dayopns: [{
        id: 1,
        name: '1日'
      }, {
        id: 2,
        name: '2日'
      },
      {
        id: 3,
        name: '3日'
      }, {
        id: 4,
        name: '4日'
      }, {
        id: 5,
        name: '5日'
      }, {
        id: 6,
        name: '6日'
      }, {
        id: 7,
        name: '7日'
      }, {
        id: 8,
        name: '8日'
      }, {
        id: 9,
        name: '9日'
      }, {
        id: 10,
        name: '10日'
      }, {
        id: 11,
        name: '11日'
      }, {
        id: 12,
        name: '12日'
      }, {
        id: 13,
        name: '13日'
      }, {
        id: 14,
        name: '14日'
      }, {
        id: 15,
        name: '15日'
      }, {
        id: 16,
        name: '16日'
      }, {
        id: 17,
        name: '17日'
      }, {
        id: 18,
        name: '18日'
      }, {
        id: 19,
        name: '19日'
      }, {
        id: 20,
        name: '20日'
      }, {
        id: 21,
        name: '21日'
      }, {
        id: 22,
        name: '22日'
      }, {
        id: 23,
        name: '23日'
      }, {
        id: 24,
        name: '24日'
      }, {
        id: 25,
        name: '25日'
      }, {
        id: 26,
        name: '26日'
      }, {
        id: 27,
        name: '27日'
      }, {
        id: 28,
        name: '28日'
      }, {
        id: 29,
        name: '29日'
      }, {
        id: 30,
        name: '30日'
      }, {
        id: 31,
        name: '31日'
      }],
      // 定点上传月
      hourval: '',
      Houropns: [
        {
          id: 0,
          name: '0时'
        }, {
          id: 1,
          name: '1时'
        }, {
          id: 2,
          name: '2时'
        },
        {
          id: 3,
          name: '3时'
        }, {
          id: 4,
          name: '4时'
        }, {
          id: 5,
          name: '5时'
        }, {
          id: 6,
          name: '6时'
        }, {
          id: 7,
          name: '7时'
        }, {
          id: 8,
          name: '8时'
        }, {
          id: 9,
          name: '9时'
        }, {
          id: 10,
          name: '10时'
        }, {
          id: 11,
          name: '11时'
        }, {
          id: 12,
          name: '12时'
        }, {
          id: 13,
          name: '13时'
        }, {
          id: 14,
          name: '14时'
        }, {
          id: 15,
          name: '15时'
        }, {
          id: 16,
          name: '16时'
        }, {
          id: 17,
          name: '17时'
        }, {
          id: 18,
          name: '18时'
        }, {
          id: 19,
          name: '19时'
        }, {
          id: 20,
          name: '20时'
        }, {
          id: 21,
          name: '21时'
        }, {
          id: 22,
          name: '22时'
        }, {
          id: 23,
          name: '23时'
        }],
      // 定点上传日、时
      hourfsis: '',
      hoursopns: [
        {
          id: 0,
          name: '0时'
        }, {
          id: 1,
          name: '1时'
        }, {
          id: 2,
          name: '2时'
        },
        {
          id: 3,
          name: '3时'
        }, {
          id: 4,
          name: '4时'
        }, {
          id: 5,
          name: '5时'
        }, {
          id: 6,
          name: '6时'
        }, {
          id: 7,
          name: '7时'
        }, {
          id: 8,
          name: '8时'
        }, {
          id: 9,
          name: '9时'
        }, {
          id: 10,
          name: '10时'
        }, {
          id: 11,
          name: '11时'
        }, {
          id: 12,
          name: '12时'
        }, {
          id: 13,
          name: '13时'
        }, {
          id: 14,
          name: '14时'
        }, {
          id: 15,
          name: '15时'
        }, {
          id: 16,
          name: '16时'
        }, {
          id: 17,
          name: '17时'
        }, {
          id: 18,
          name: '18时'
        }, {
          id: 19,
          name: '19时'
        }, {
          id: 20,
          name: '20时'
        }, {
          id: 21,
          name: '21时'
        }, {
          id: 22,
          name: '22时'
        }, {
          id: 23,
          name: '23时'
        }],
      // 添加
      bushuData: {
        address: null,
        location: null,
        meter: null,
        name: null,
        pay_id: null,
        phone: null
      },
      // 主体数据
      parData: [{
        username: null,
        address: null,
        balance: null,
        meter_id: null,
        meter_status: null,
        meter_type: null,
        name: null,
        pay_id: null,
        phone: null,
        water_type: null
      }],
      famlis: {
        token: null,
        pagesize: 20,
        pagenum: 1,
        search_content: null,
        community_id: null,
        building_id: null,
        unit_id: null,
        room_id: null
      },
      total: null,
      cuansstotal: null,
      userBmfi: {
        project_id: null,
        token: null,
        pay_id: null
      },
      project_id: null,
      userfima: {
        project_id: null,
        pay_id: null,
        token: null,
        meter_id: 0
      },
      // 下拉框
      // 获取小区
      quarters: [{
        id: null,
        name: null
      }],
      // 获取楼栋
      Buildings: [{
        id: null,
        name: null
      }],
      // 获取单元
      units: [{
        id: null,
        name: null
      }],
      // 获取房间
      roomsfas: [{
        id: null,
        name: null
      }],
      // 欠费不欠费
      yugecans: [{
        id: 0,
        name: '不欠费'
      }, {
        id: 1,
        name: '欠费'
      }],
      valveStatuses: [{
        id: '阀开',
        name: '阀开'
      }, {
        id: '无阀门',
        name: '无阀门'
      }],
      // 小区参数
      comities: {
        token: null
      },
      munity: null,
      // 楼栋参数
      buings: {
        token: null,
        community_id: null
      },
      unis: null,
      // 单元参数
      unistfs: {
        token: null,
        building_id: null
      },
      rom: null,
      // 房间参数
      roomfs: {
        token: null,
        unit_id: null
      },
      zaisns: [{
        id: 1,
        name: null
      }],
      cxyts: {
        project_id: null,
        token: null,
        pay_id: null,
        search_content: null,
        location_id: null,
        insufficient_balance: null,
        community_id: null,
        building_id: null,
        unit_id: null,
        room_id: null,
        owing: null,
        pagenum: 1,
        pagesize: 20
      },
      ValveControl: {
        token: null,
        regional_issued: false,
        community_id: null,
        building_id: null,
        unit_id: null,
        room_id: null,
        meter_id_list: [],
        lengthid: null,
        optionId: 1,
        params: {
          d1: null
        }
      },
      ccnn: null,
      ccoo: null,
      ooo: null,
      fff: null,
      ioio: null,
      ishuor: null,
      isdayst: null,
      uuu: null,
      list: [],
      cuanss: {
        token: null,
        meter_id: null,
        pagesize: 20,
        pagenum: 1
      },
      rdais: {
        token: null,
        meter_id_list: [],
        day_date: null,
        month_date: null
      },
      currentDateStart: null,
      shijainfa: null,
      hompp: null,
      homii: null,
      aaa: null,
      Dailws: '',
      Hourws: '',
      Dayedes: null,
      watefamlstotal: null,
      watefamls: {
        meter_id: null,
        token: null,
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10
      },
      ids: [],
      // 区域导出
      qudaoCans: {
        token: null,
        community_id: null,
        building_id: null,
        unit_id: null,
        room_id: null,
        owing: null,
        pagesize: null,
        pagenum: 1
      },
      today: new Date(),
      formattedDate: null
    }
  },
  computed: {
    dialogPaginationLayout () {
      return this.isMobile ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'
    }
  },
  created () {
    this.famlis.project_id = this.$store.state.print.goodsForeNo.project_id
    this.famlis.token = this.$store.state.print.goodsForeNo.token
    this.userBmfi.project_id = this.$store.state.print.goodsForeNo.project_id
    this.userBmfi.token = this.$store.state.print.goodsForeNo.token
    this.project_id = this.$store.state.print.goodsForeNo.project_id
    this.fasdData()
    this.watefData()
    // 下拉框
    // 获取小区
    this.residential()
    // 获取楼栋
    this.Building()
    // 单元
    this.unit()
    // 房间
    this.room()
    // this.CxunR()
    this.resetScrollPosition()
    if (typeof window !== 'undefined') {
      this.isMobile = window.innerWidth <= 768
    }
    // 解析路由参数
    const owingStatus = parseInt(this.$route.query.owingStatus)
    if (!isNaN(owingStatus)) {
      // 设置欠费筛选状态
      this.famlis.owing = owingStatus
      this.qudaoCans.owing = 1
      // 立即触发查询
      this.userData()
      // 清除路由参数，避免影响后续操作
      this.$router.replace({ query: {} })
    } else {
      this.userData()
    }
  },
  watch: {
    // 隐藏与显示持久化
    visibleList: {
      handler (newVal) {
        localStorage.setItem('upToData_visibleList', JSON.stringify(newVal))
      },
      deep: true
    },
    // 账号切换时重置隐藏列
    '$store.state.print.goodsForeNo': {
      handler (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          // 清除本地存储
          localStorage.removeItem('upToData_visibleList')
          // 重置 visibleList
          this.visibleList = []
          this.columnList.forEach((col, index) => {
            if (col.defaultVisible && !this.hideColumnIndexs.includes(index)) {
              this.visibleList.push(index)
            }
          })
        }
      },
      deep: true
    }
  },
  mounted () {
    // 优先读取本地存储
    const saved = localStorage.getItem('upToData_visibleList')
    if (saved) {
      try {
        this.visibleList = JSON.parse(saved)
      } catch (e) {
        this.visibleList = []
      }
    } else {
      // 初始化显示的列
      this.columnList.forEach((col, index) => {
        if (col.defaultVisible && !this.hideColumnIndexs.includes(index)) {
          this.visibleList.push(index)
        }
      })
    }

    // 仅手机端：下拉选项 touchend 直接触发 click，避免需要点两次
    try {
      const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 768px)').matches
      if (isMobile) {
        this._mobileSelectTouchEndHandler = (e) => {
          const target = e && e.target
          if (!target || !target.closest) return
          const item = target.closest('.mobile-select-popper .el-select-dropdown__item')
          if (!item) return
          if (item.classList && item.classList.contains('is-disabled')) return
          e.preventDefault()
          e.stopPropagation()
          item.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }))
        }
        document.body.addEventListener('touchend', this._mobileSelectTouchEndHandler, { passive: false })
      }
    } catch (err) {
      // ignore
    }

    this.checkDialogMobile()
    window.addEventListener('resize', this.checkDialogMobile, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkDialogMobile)
    if (this._mobileSelectTouchEndHandler) {
      document.body.removeEventListener('touchend', this._mobileSelectTouchEndHandler)
      this._mobileSelectTouchEndHandler = null
    }
  },
  methods: {
    checkDialogMobile () {
      this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 768
    },
    onTableCodeDialogOpened () {
      if (!this.isMobile) return
      this.$nextTick(() => {
        const comp = this.$refs.tableCodeInput
        if (comp && typeof comp.focus === 'function') {
          comp.focus()
        }
      })
    },
    getMobileDetailEntries () {
      const row = this.mobileDetailRow || {}
      return MOBILE_DETAIL_FIELD_CONFIG.map(({ key, t }) => {
        const v = row[key]
        return {
          key,
          label: this.$t(t),
          value: v === null || v === undefined || v === '' ? '-' : v
        }
      })
    },
    getSubTableDetailEntries () {
      const row = this.subTableDetailRow || {}
      const fieldConfigMap = {
        history: MOBILE_HISTORY_DETAIL_FIELD_CONFIG,
        process: MOBILE_PROCESS_DETAIL_FIELD_CONFIG,
        daily: MOBILE_DAILY_DETAIL_FIELD_CONFIG
      }
      const fields = fieldConfigMap[this.subTableDetailType] || []
      return fields.map(({ key, t }) => {
        let value = row[key]
        if (key === 'finished') {
          value = value === true || value === 'true' || value === 0 ? this.$t('QueryDailyUsage.是') : this.$t('QueryDailyUsage.否')
        }
        return {
          key,
          label: this.$t(t),
          value: value === null || value === undefined || value === '' ? '-' : value
        }
      })
    },
    openSubTableDetail (type, row) {
      this.subTableDetailType = type
      this.subTableDetailRow = { ...(row || {}) }
      this.subTableDetailVisible = true
    },
    handleMobileRowCommand (cmd, row) {
      if (!row) return
      if (cmd === 'progress') this.cxunbtn(row)
      else if (cmd === 'curve') this.YYQXbtn(row)
      else if (cmd === 'history') this.history(row)
      else if (cmd === 'daily') this.TableDailyUsage(row)
      else if (cmd === 'code') this.TablecodeBtn(row)
      else if (cmd === 'detail') {
        this.mobileDetailRow = { ...row }
        this.mobileDetailVisible = true
      }
    },
    handleValveControlCommand (cmd) {
      if (cmd === 'open') this.Openvalve()
      else if (cmd === 'close') this.Closevalve()
      else if (cmd === 'alarmClose') this.Callvalve()
      else if (cmd === 'test') this.Testvalve()
    },
    // 封装滚动条重置逻辑
    resetScrollPosition (direction = 'both') {
      this.$nextTick(() => {
        const tableRef = this.$refs.historyTable
        if (!tableRef?.$el) return

        const scrollBody = tableRef.$el.querySelector('.el-table__body-wrapper')
        if (!scrollBody) return

        // 现代浏览器推荐使用 scrollTo
        switch (direction) {
          case 'vertical':
            scrollBody.scrollTo({ top: 0, behavior: 'auto' })
            break
          case 'horizontal':
            scrollBody.scrollTo({ left: 0, behavior: 'auto' })
            break
          default: // both
            scrollBody.scrollTo({ top: 0, left: 0, behavior: 'auto' })
        }
      })
    },
    // 弹框关闭
    handleClosed () {
      // 关闭查询日用水后的清理逻辑
      this.TableDailyUsageData = []
      this.dailyTime = []
      this.TableDailyUsageparameter.start_date = null
      this.TableDailyUsageparameter.end_date = null
      // 录入表码（与字符串 v-model 一致，避免 null 导致手机端输入异常）
      this.tabcode.flow = ''
    },
    // 获取日用水
    TableDailyUsage (row) {
      this.QueryDailyUsage = true
      this.TableDailyUsageparameter.token = this.$store.state.print.goodsForeNo.token
      this.TableDailyUsageparameter.meter_id = row.meter_id
      this.$api.waterMeter.meterFlowUse(this.TableDailyUsageparameter).then((res) => {
        if (res.data.status === 'success') {
          this.TableDailyUsageData = res.data.data
          this.DailyUsagetotal = res.data.total
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
      })
    },
    // 查询日用水按钮
    QueryDailyUsagebtn () {
      this.TableDailyUsageparameter.start_date = this.dailyTime[0]
      this.TableDailyUsageparameter.end_date = this.dailyTime[1]
      // 修改为直接调用API而不是调用TableDailyUsage方法
      this.TableDailyUsageparameter.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterMeter.meterFlowUse(this.TableDailyUsageparameter).then((res) => {
        if (res.data.status === 'success') {
          this.TableDailyUsageData = res.data.data
          this.DailyUsagetotal = res.data.total
          // 重置滚动条位置（Vue2兼容写法）
          this.resetScrollPosition()
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
      })
    },
    // 重置
    Resetbtn () {
      this.dailyTime = []
      this.TableDailyUsageparameter.start_date = null
      this.TableDailyUsageparameter.end_date = null
      this.TableDailyUsageparameter.pagenum = 1
      this.TableDailyUsageparameter.pagesize = 20
      this.$api.waterMeter.meterFlowUse(this.TableDailyUsageparameter).then((res) => {
        if (res.data.status === 'success') {
          this.TableDailyUsageData = res.data.data
          this.DailyUsagetotal = res.data.total
          this.resetScrollPosition()
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
      })
    },
    QueryDailyUsageSizeChange (val) {
      this.TableDailyUsageparameter.pagesize = val
      this.QueryDailyUsagebtn()
    },
    QueryDailyUsageCurrentChange (val) {
      this.TableDailyUsageparameter.pagenum = val
      this.QueryDailyUsagebtn()
    },
    // 录入表码
    TablecodeBtn (row) {
      this.tabcode.meter_id = row.meter_id
      this.tabcode.flow = ''
      this.TableCold = true
    },
    GinBaous () {
      this.tabcode.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterMeter.meterSetFlow(this.tabcode).then((res) => {
        if (res.data.status === 'success') {
          this.tabcode.flow = ''
          this.TableCold = false
          this.$message.success(res.data.message)
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
      })
    },
    yesterday () {
      const yesterday = new Date(this.today)
      yesterday.setDate(this.today.getDate() - 1)
      return yesterday
    },
    // 查看用水曲线
    YYQXbtn (row) {
      this.aioid = row.meter_id
      this.YYQXdes.token = this.$store.state.print.goodsForeNo.token
      this.YYQXdes.meter_id = row.meter_id
      this.YYQXVsibles = true
      const date = new Date(this.yesterday())
      const formattedDate = `${date.toISOString().slice(0, 10).replace(/-/g, '')}`.replace(/(.{4})(.{2})(.{2})/, '$1-$2-$3')
      this.YYQXdes.search_time = formattedDate
    },
    handleClose (done) {
      this.YYQXVsibles = false
      this.yycxshow = false
      this.YYQXdes.search_time = null
    },
    // 用水查询按钮
    YYCXbtn () {
      this.$api.waterMeter.BasedTraffic(this.YYQXdes).then((res) => {
        if (res.data.status === 'success') {
          this.timeheflow = res.data.data
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
      })
      this.yycxshow = true
    },
    // 区域导出
    quyuDaochu () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.qudaoCans.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterMeter.getmeterTable(this.qudaoCans).then((res) => {
        if (res.data.status === 'success') {
          var data = res.data.data
          var tableHeader = [
            ['缴费编号', '水表编号', '用户名', '位置', '余额', 
             '正向累计流量', '净累计流量', '反向累计流量', '瞬时流量','最新上报时间',
             '压力', '阀门状态', '信号强度','电池电压', '漏水报警',
              '液位报警', '反向计量',  '流量超限', '磁攻击', '拆卸状态', 
              '低压状态', '掉电状态','定时冻结间隔',  '上传失败次数', '水温',
             ]
          ]
          var dataList = []
          data.forEach((item, index) => {
            dataList.push([
              item.pay_id, item.meter_id, item.username, item.address, item.balance,
              item.sumFlow, item.netAccumulation, item.reverseAccumulation, item.atAccumulation, item.plotReceiveTime,
              item.yaLiF, item.valveStatus, item.signallntensity, item.batteryVoltage, item.zhuangTaiLouShui,
              item.zhuangTaiYeweibaojing, item.zhuangTaiFanXiangJiLiang, item.zhuangTaiLiuLiangChaoShangXian, item.magneticAttack,item.zhuangTaiChaiXieZhuangTai,
              item.powerLow,item.powerDown,item.dingShiDongJieJianGe,item.shiBaiShangChuanCiShu, item.shuiWenF,
            ])
          })
          dataConversionUtil.dataToExcel('水表接收与设置区域信息表', tableHeader, dataList)
          this.$message.success('导出成功!')
          this.qudaoCans.community_id = null
          this.qudaoCans.building_id = null
          this.qudaoCans.unit_id = null
          this.qudaoCans.room_id = null
          loading.close()
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
          loading.close()
        }
      })
    },
    // 月冻结参数
    Monthlyfreeze () {
      this.fixesiso.params.d2 = this.Dailws.toString().padStart(2, '0') + this.Hourws.toString().padStart(2, '0')
      this.fixesiso.token = this.$store.state.print.goodsForeNo.token
      this.fixesiso.params.d1 = '0023'
      this.$api.waterMeter.putdeviceCommand(this.fixesiso).then((res) => {
        if (res.data.status === 'success') {
          this.$notify({
            title: '成功',
            message: res.data.message,
            type: 'success'
          })
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
      })
      this.MonthlyVsibles = false
      this.reload()
    },
    // 月冻结参数按钮
    Monthlybtn () {
      this.MonthlyVsibles = true
    },
    // 日冻结参数
    DailyChange (val) {
      this.Dailws = val
    },
    // 日冻结参数按钮
    HourChange (val) {
      this.Hourws = val
    },
    // 日冻结参数按钮
    Dailybtn () {
      this.DailVsibles = true
    },
    Dailymeters (val) {
      this.Dailyparameters = val
    },
    Dailyparametersbtn () {
      this.fixesiso.params.d2 = this.Dailyparameters.replace(/:/g, '')
      this.fixesiso.token = this.$store.state.print.goodsForeNo.token
      this.fixesiso.params.d1 = '0123'
      this.$api.waterMeter.putdeviceCommand(this.fixesiso).then((res) => {
        if (res.data.status === 'success') {
          this.$notify({
            title: '成功',
            message: res.data.message,
            type: 'success'
          })
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
      this.DailVsibles = false
      this.reload()
    },
    // 日期确定---开始时间
    // 标准时间转年月日
    formreDate (date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    rekois (data) {
      this.currentDateStart = this.formatDate(data) // 将获取到的时间调用formatDate方法转换成年月日
      this.rdais.day_date = this.currentDateStart
    },
    // 月冻结数据
    residata () {
      this.rdais.token = this.$store.state.print.goodsForeNo.token
      this.rdais.day_date = null
      this.$api.waterMeter.getdeviceFrozenData(this.rdais).then((res) => {
        if (res.data.status === 'success') {
          this.yuedatas = res.data.data
          this.$notify({
            title: '成功',
            message: res.data.message,
            type: 'success'
          })
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    // 日期确定---开始时间
    // 标准时间转年月日
    formatDate (date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    er (data) {
      this.currentDateStart = this.formatDate(data) // 将获取到的时间调用formatDate方法转换成年月日
      this.rdais.month_date = this.currentDateStart
    },
    fixedbtn () {
      this.fixedVsibles = true
    },
    // 日冻结数据
    fasidata () {
      this.rdais.token = this.$store.state.print.goodsForeNo.token
      this.rdais.month_date = null
      this.$api.waterMeter.getdeviceFrozenData(this.rdais).then((res) => {
        if (res.data.status === 'success') {
          this.redatas = res.data.data
          this.$notify({
            title: '成功',
            message: res.data.message,
            type: 'success'
          })
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    yuedata () {
      this.yueVsibles = true
    },
    ridojie () {
      this.rdjVsibles = true
    },
    // 周期上传
    zqiosbtn () {
      this.zqiVsibles = true
    },
    // 上传间隔
    jiangebtn () {
      this.interval.token = this.$store.state.print.goodsForeNo.token
      this.interval.optionId = 5
      this.interval.params.d1 = '1123'
      this.$api.waterMeter.putdeviceCommand(this.interval).then((res) => {
        if (res.data.status === 'success') {
          this.$notify({
            title: '成功',
            message: res.data.message,
            type: 'success'
          })
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
      this.reload()
    },
    // 周期时间
    zqibtn () {
      this.hompp = this.homemo[0]
      this.homii = this.homemo[1]
      this.aaa = this.hompp + ';' + this.homii + ';' + '05'
      // this.fixesiso.params.d2 = this.aaa.split(':').join('') //和下面两种方法都可以 左右去掉对象中的:号
      this.fixesiso.params.d2 = this.aaa.replace(/:/g, '')
      this.fixesiso.token = this.$store.state.print.goodsForeNo.token
      this.fixesiso.params.d1 = '1223'
      this.$api.waterMeter.putdeviceCommand(this.fixesiso).then((res) => {
        if (res.data.status === 'success') {
          this.$notify({
            title: '成功',
            message: res.data.message,
            type: 'success'
          })
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
      })
    },
    chanvalu (val) {
      this.homemo = val
    },
    handleChange (val) {
      this.this.fixesiso.params.d2 = val
    },
    // 定点上传参数
    // 提交按钮
    faixbtn () {
      this.fixesiso.token = this.$store.state.print.goodsForeNo.token
      // d1的参数
      var array = ['1124', '1224', '1324', '1424']
      // 选择日
      this.fansd.forEach((item, index) => {
        this.fff = item
      })
      var arrsy = [0, 1, 2, 3]
      // this.lengths = this.fansd.length-1
      arrsy.forEach((item, index) => {
        this.fixesiso.params.d1 = array[item]
        this.ishuor = this.fansd[item]
        if (this.isyue) {
          this.isdayst = this.ishuor.toString().padStart(2, '0') + this.huoers.toString().padStart(2, '0')
        } else {
          this.isdayst = this.ishuor.toString().padStart(4, '0')
        }
        if (index > this.fansd.length - 1) {
          this.isdayst = '9900'
        }
        this.fixesiso.params.d2 = this.isdayst
        this.$api.waterMeter.putdeviceCommand(this.fixesiso).then((res) => {
          if (item === this.fansd.length - 1) {
            if (res.data.status === 'success') {
              this.$notify({
                title: '成功',
                message: res.data.message,
                type: 'success'
              })
            } else if (res.data.status === 'error') {
              this.$message.error(res.data.message)
            }
          }
          this.fixedVsibles = this.false
        })
      })
      this.reload()
    },
    // 取消按钮
    faixvals () {
      this.fixedVsibles = false
    },
    // 选择月/日
    monthChange (val) {
      if (val !== 1) {
        this.isyue = false
        this.isday = true
      } else {
        this.isyue = true
        this.isday = false
      }
    },
    // 月，日
    dayChange (val) {
      this.fansd = val
    },
    // 月，时
    hourChange (val) {
      this.huoers = val
    },
    // 日、时
    hoursChange (val) {
      this.fansd = val
    },
    // 查询历史纪录
    history (row) {
      this.ccoo = row.meter_id
      this.historyVsibles = true
      this.watefamls.token = this.$store.state.print.goodsForeNo.token
      this.watefamls.meter_id = this.ccoo
      this.$api.waterMeter.wateDatas(this.watefamls).then((res) => {
        if (res.data.status === 'success') {
          this.tableData = res.data.data
          this.watefamlstotal = res.data.total
        }
      })
    },
    // 查询设备进程
    cxunbtn (row) {
      this.dialgVsibles = true
      this.cuanss.token = this.$store.state.print.goodsForeNo.token
      this.ccnn = row.meter_id
      this.cuanss.meter_id = this.ccnn
      this.$api.waterMeter.getdeviceCommand(this.cuanss).then((res) => {
        if (res.data.status === 'success') {
          this.bansdata = res.data.data
          this.cuansstotal = res.data.total
          this.resetScrollPosition()
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
          this.bansdata = null
        }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    CxunR () {
      this.$api.waterMeter.getdeviceCommand(this.cuanss).then((res) => {
        if (res.data.status === 'success') {
          this.bansdata = res.data.data
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    // 开阀取消
    OpenCancel () {
      this.tianjiaVisible = this.false
      this.CloseVisible = this.false
      this.callCloseVisible = false
      this.TestCloseVisible = false
      this.ValveControl.regional_issued = false
    },
    // 开阀提交
    OpenSubmit () {
      this.ValveControl.token = this.$store.state.print.goodsForeNo.token
      this.$api.waterMeter.putdeviceCommand(this.ValveControl).then((res) => {
        if (res.data.status === 'success') {
          this.$notify({
            title: '成功',
            message: res.data.message,
            type: 'success'
          })
        } else if (res.data.status === 'error') { this.$message.error(res.data.message) }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
        this.tianjiaVisible = this.false
        this.CloseVisible = this.false
      })
      this.TestCloseVisible = false
    },
    // 开阀按钮
    Openvalve () {
      this.ValveControl.params.d1 = 28
      this.tianjiaVisible = true
    },
    // 关阀按钮
    Closevalve () {
      this.ValveControl.params.d1 = 26
      this.CloseVisible = true
    },
    // 报警关阀
    Callvalve () {
      this.ValveControl.params.d1 = 27
      this.callCloseVisible = true
    },
    // 阀门测试
    Testvalve () {
      this.ValveControl.params.d1 = 29
      this.TestCloseVisible = true
    },
    // table选择
    handleSelectionChange (val) {
      if(val.length > 0){
        this.commandBan = true
        this.ValveControl.regional_issued = false // 开阀等
        this.fixesiso.regional_issued = false // 定点上传选择框
      } else {
        this.commandBan = false
      }
      this.ids = val.map(item => item.pay_id)
      // 选中的条数
      this.ValveControl.meter_id_list = val
      this.fixesiso.meter_id_list = val
      this.ValveControl.lengthid = val.length
      this.interval.meter_id_list = val
      this.rdais.meter_id_list = val
    },
    rowStyle ({ row, rowIndex }) {
      var arrs = this.ids
      for (let i = 0; i < arrs.length; i++) {
        if (row.pay_id === arrs[i]) {
          return 'rowStyle'
        }
      }
    },
    // 获取小区
    residential () {
      this.comities.token = this.$store.state.print.goodsForeNo.token
      this.$api.userProfile.communities(this.comities).then((res) => {
        this.quarters = res.data.data
      })
    },
    selectQuarters (val) {
      this.regionName = this.quarters.find(item => item.id === val).name
      this.positionName = '小区'
      this.munity = val
      this.ValveControl.community_id = val
      this.interval.community_id = val
      this.fixesiso.community_id = val
      this.qudaoCans.community_id = val // 区域导出
      this.famlis.building_id = null
      this.famlis.unit_id = null
      this.famlis.room_id = null
      this.Building()
    },
    // 获取楼栋
    Building () {
      this.buings.token = this.$store.state.print.goodsForeNo.token
      this.buings.community_id = this.munity
      this.$api.userProfile.buildings(this.buings).then((res) => {
        this.Buildings = res.data.data
      })
    },
    selectBuildings (val) {
      this.regionName = this.Buildings.find(item => item.id === val).name
      this.positionName = '楼栋'
      this.unis = val
      this.ValveControl.building_id = val
      this.interval.building_id = val
      this.fixesiso.building_id = val
      this.qudaoCans.building_id = val // 区域导出
      this.famlis.unit_id = null
      this.famlis.room_id = null
      this.unit()
    },
    // 单元
    unit () {
      this.unistfs.token = this.$store.state.print.goodsForeNo.token
      this.unistfs.building_id = this.unis
      this.$api.userProfile.units(this.unistfs).then((res) => {
        this.units = res.data.data
      })
    },
    selectunit (val) {
      this.regionName = this.units.find(item => item.id === val).name
      this.positionName = '单元'
      this.rom = val
      this.ValveControl.unit_id = val
      this.interval.unit_id = val
      this.fixesiso.unit_id = val
      this.qudaoCans.unit_id = val // 区域导出
      this.famlis.room_id = null
      this.room()
    },
    // 房间
    room () {
      this.roomfs.token = this.$store.state.print.goodsForeNo.token
      this.roomfs.unit_id = this.rom
      this.$api.userProfile.rooms(this.roomfs).then((res) => {
        this.roomsfas = res.data.data
      })
    },
    selectroom (val) {
      this.regionName = this.roomsfas.find(item => item.id === val).name
      this.positionName = '房间'
      this.ValveControl.room_id = val
      this.interval.room_id = val
      this.fixesiso.room_id = val
      this.qudaoCans.room_id = val // 区域导出
    },
    seleYuer (val) {
      this.qudaoCans.owing = val
      this.userData()
    },
    seleValveStatus (val) {
      this.qudaoCans.valveStatus = val
      this.userData()
    },
    // 查询
    pay_search () {
      this.userData()
    },
    // 刷新
    shuaxin () {
      this.reload()
    },
    // 主体数据
    userData () {
      this.$api.waterMeter.getmeterTable(this.famlis).then((res) => {
        if (res.data.status === 'success') {
          this.parData = res.data.data
          this.total = res.data.total
          // 重置滚动条位置（Vue2兼容写法）
          this.$nextTick(() => {
            const tableRef = this.$refs.historyTable
            if (tableRef && tableRef.$el) {
              const scrollBody = tableRef.$el.querySelector(
                '.el-table__body-wrapper'
              )
              if (scrollBody) {
                scrollBody.scrollTop = 0
                scrollBody.scrollLeft = 0 // 同时重置左右滚动条
              }
            }
          })
          this.qudaoCans.pagesize = res.data.total
          if (this.total === 0) {
            this.zanwu = true
          }
        } else if (res.data.status === 'error') {
          this.$message.error(res.data.message)
        }
        if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    fasdData () {
      this.$api.waterMeter.getdeviceCommand(this.cuanss).then((res) => {
        if (res.data.status === 'success') {
          this.bansdata = res.data.data
          this.cuansstotal = res.data.total
        } else if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    // 查询历史纪录
    watefData () {
      this.$api.waterMeter.wateDatas(this.watefamls).then((res) => {
        if (res.data.status === 'success') {
          this.tableData = res.data.data
          this.watefamlstotal = res.data.total
          this.resetScrollPosition()
        } else if (res.data.message === '用户在别处登录') {
          this.$router.push('/', this.fasinull)
        }
      })
    },
    // 监听 pagesize 改变的事件
    handleSizeChange (newSize) {
      this.famlis.pagesize = newSize
      this.userData()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange (newPage) {
      this.famlis.pagenum = newPage
      this.userData()
    },
    // 查询设备进程
    processSizeChange (newSize) {
      this.cuanss.pagesize = newSize
      this.cuanss.meter_id = this.ccnn
      this.fasdData()
    },
    // 监听 页码值 改变的事件
    processCurrentChange (newPage) {
      this.cuanss.pagenum = newPage
      this.cuanss.meter_id = this.ccnn
      this.fasdData()
    },
    // 历史记录
    watefamlsSizeChange (newSize) {
      this.watefamls.pagesize = newSize
      this.watefamls.meter_id = this.ccoo
    },
    // 监听 页码值 改变的事件
    watefamlsCurrentChange (newPage) {
      this.watefamls.pagenum = newPage
      this.watefamls.meter_id = this.ccoo
      this.watefData()
    }
  }
}

</script>

<style lang="less" scoped>
/deep/.rowStyle{
      background-color: oldlace !important;
    }
.T{
    padding: 0;
}
/* 定点上传 / 月冻结参数等处：电脑端保留不换行空格，手机端去掉以免挤占纵向布局 */
.wm-nbsp-desktop {
  display: none;
}
@media (min-width: 769px) {
  .wm-nbsp-desktop {
    display: inline;
  }
  .wm-nbsp-desktop::before {
    content: '\00a0';
  }
}
// 面包屑
.Gnv {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #ecf0f1;
  font-size: 19px;
  letter-spacing: 1px;
  //   font-family: myFont;
  .el-breadcrumb {
    display: flex;
    align-items: center;
    margin-left: 20px;
    .yai{
      width: 5px;
      height: 17px;
      background-color: #987AFF;
      margin-right: 18px;
    }
    ::v-deep .el-breadcrumb__item{
      margin-left: 0px;
      .el-breadcrumb__inner.is-link{
        font-weight: 100;
        color: #656d92;
  }
    }
  }
}
// 搜索
.suso {
  // width: 900px;
  padding: 20px 0px 0px 20px;
  // display: flex;
  // border: 1px solid #474747;
  .el-form {
    display: flex;
    flex-wrap: wrap;
    .el-input {
      width: 200px;
    }
    .el-button {
      margin-left: 10px;
      background-color: #744dfe;
      border: 0px;
    }
    .el-form-item{
      margin-bottom: 9px;
      display: flex;
      .ilo{
      cursor: pointer;
      width: 102px;
      height: 33px;
      border-radius: 4px;
      border: solid 1px #977aff;
      font-size: 22px;
      color: #656d92;
      display: flex;
      justify-content: center;
      align-items: center;
    }
      .ili{
      cursor: pointer;
      width: 102px;
      height: 33px;
      border-radius: 4px;
      border: solid 1px #977aff;
      font-size: 22px;
      color: #656d92;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .el-select{
      width: 150px;
    }
    }
  }
}
// 主体区域
.navto {
display: flex;
flex-wrap: wrap;
padding: 0px 0px 50px 57px;
.num {
    margin-top: 13px;
    margin-left: 17px;
    width: 368px;
    height: 253px;
    background-color: #ffffff;
    box-shadow: 1px 1px 5px 1px rgba(116, 77, 254, 0.5);
    border-radius: 7px;
    border: solid 2px #c6c6c6;
    line-height: 31px;
  .iconfont {
    font-size: 30px;
    color: #744dfe;
  }
  .num1 {
      padding: 10px 10px;
      display: flex;
      align-items: center;
    span {
      margin-left: 20px;
      font-family: PingFangSC-Heavy;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 31px;
      letter-spacing: 2px;
      color: #474747;
    }
    .el-button {
      float: right;
      margin-left: 30px;
      background-color: #F5F5F5;
      color: #9FA2AE;
      border: 1px solid #DDD5FC;
    }
  }
  .numsop{
    font-family: PingFangSC-Heavy;
    font-size: 18px;
    font-weight: normal;
    letter-spacing: 2px;
    color: #656d92;
    padding-left: 60px;
  }
  .num2 {
    .num-1{
        padding: 0px 10px;
        .nui{
          margin-left: 19px;
        }
        span{
          font-family: MiSans-Normal;
          font-size: 16px;
          font-weight: normal;
          letter-spacing: 2px;
          color: #656d92;
        }
    }
    .nummane{
      line-height: 50px;
      padding-left: 60px;
      font-family: MiSans-Normal;
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 2px;
      color: #656d92;
    }
    .num-2{
        text-align: center;
        padding: 10px 0px;
        color: #9194AF;
    }
    .num-3{
        padding: 3px 0px;
        span{
            padding: 0px 45px;
        }
    }
  }
  .numbtn{
      margin-top: 15px;
         border-top: 1px solid #DED6FF;
         padding: 5 px 0px;
         display: flex;
         justify-content: space-between;
     }
     .numbtns{
       margin-top: 10px;
        display: flex;
         justify-content: space-between;
       .el-button{
             width: 33%;
             border: none;
             border-right: 1px solid #DED6FF;
             font-family: MicrosoftYaHei;
            font-size: 16px;
            font-weight: normal;
            letter-spacing: 2px;
            // color: #474747;
         }
        .btnbang{
          background-color: #909399;
          color: #fff;
        }
         .el-button:nth-child(3){
             border-right: none;
         }
     }
}
}
// 分页
.feye{
  background-color: rgb(247, 245, 245);
  width: 1542px;
  height: 40px;
  position: fixed;
  right: 20px;
  bottom: 0;
}
// 暂无数据
.wuju{
  margin-left: 40%;
  margin-top: 15%;
}
// <!-- table表格 -->
    .tab{
        padding: 30px 30px 0px 20px;
        // 分页
        .el-pagination{
          ::v-deep .el-pagination__rightwrapper{
            float: left;
            margin-left: 20px;
          }
        }
        .el-card{
            ::v-deep .el-table th.el-table__cell{
              background-color: #987AFF;
            }
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
          .table_bock{
            margin: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .trends_oprt_wrap{
              .el-button{
              background-color: #FFF;
              border: 1px solid#DCDFE6;
              color: #6F7174;
              }
            }
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
          background-color: #744dfe;
          padding:10px 10px 10px 10px ;
          color: #FFF;
          letter-spacing: 3px;
        }
    }
    // 按钮区域
    .ButtonArea{
        display: flex;
        flex-wrap: wrap;
        // margin-left: 54px;
        margin-top: 10px;
        .el-button{
            margin-left: 20px;
            background-color: #744dfe;
            color: #fff;
            letter-spacing: 4px;
            border: 0px;
        }
    }
    // 开阀操作
    .locationOpenvalve{
      .el-dialog__wrapper{
  ::v-deep .el-dialog{
    width: 30%;
  }
}
      .el-form{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        .el-form-item{
          width: 51%;
          span{
            color: #A9A9A9;
            font-size: 18px;
          }
          .el-checkbox{
            ::v-deep .el-checkbox__label{
               color: #FF9D0B;
              font-size: 18px;
            }
          }
        }
      }
    }
    // 查询进程
    .wwoop{
      display: flex;
      justify-content: space-between;
      padding-bottom: 16px;
      .el-icon-refresh-right{
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #928d8d;
        font-size: 16px;
      }
    }
    .zhuos{
      margin-top: 20px;
      color: brown;
    }
    /* 定点上传：桌面端多选「时」宽度（手机端由 wm-btn-area-dialog 覆盖为 100%） */
    .cyclKai .wm-dingdian-hour-select {
      width: 300px;
      max-width: 100%;
    }
    // <!-- table表格 -->
    .rdojie{
      margin-top: 20px;
        // padding: 30px 30px 0px 74px;
        // 分页
        .el-pagination{
          ::v-deep .el-pagination__rightwrapper{
            float: left;
            margin-left: 20px;
          }
        }
        .el-card{
            ::v-deep .el-table th.el-table__cell{
              background-color: #987AFF;
            }
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
          background-color: #744dfe;
          color: #FFF;
          letter-spacing: 3PX;
        }
    }
    .Periodic{
      align-items: center;
      margin-bottom: 20px;
    }
    // 修改区域
    .elform{
    margin-left: 20px;
  }
  .cycle{
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 30%;
    .Periodic{
        display: flex;
        justify-content: space-between;
      }
      .time{
        display: flex;
        align-items: center;
      }
      .block{
        display: flex;
        align-items: center;
        .el-select{
          width: 100px;
        }
      }
    }
  }
  }
  .cyclKai{
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 40%;
    .Periodic{
        display: flex;
        justify-content: space-between;
      }
      .time{
        display: flex;
        align-items: center;
      }
      .block{
        display: flex;
        align-items: center;
        .el-select{
          width: 100px;
        }
      }
    }
  }
  }
  .Number-table-codes{
    .el-dialog__wrapper{
      ::v-deep .el-dialog{
        width: 20%;
      }
    }
  }
  @media (min-width: 768px) {
    .suso-desktop{
      display: block !important;
    }
    .suso-mobile{
      display: none !important;
    }
    .formBtn{
      display: none;
    }
    .mobile-query-row{
      display: none !important;
    }
    .moveab{
      display: none;
    }
    }
    // 移动端
    @media (max-width: 768px) {
      .Gnv{
        display: none;
      }
      .suso{
        padding: 10px 10px 0px 10px;
      }
      .tab{
        display: none;
      }
      .elform{
        margin-left: 0px;
      }
      .elfomobtn {
      display: none;
    }
    .el-form{
      .el-form-item{
        ::v-deep .el-form-item__content{
          display: flex;
        }
      }
  }
  .suso .el-form .el-form-item{
    margin-bottom: 2px;
  }
  .ButtonArea{
    margin-left: 0px;
    margin-top: 10px;
    .el-button{
      margin-left: 10px;
      background-color: #744dfe;
      color: #fff;
      letter-spacing: 2px;
      border: 0px;
      font-size: 12px;
      margin: 6px 4px;
      padding: 10px 14px;
    }
  }
  .moveab{
    margin: 10px 10px;
    .el-pagination{
          ::v-deep .el-pagination__rightwrapper{
            float: left;
            margin-left: 20px;
          }
        }
        .el-card{
            ::v-deep .el-table th.el-table__cell{
              background-color: #987AFF;
            }
          border-radius: 10px;
          ::v-deep .el-card__body{
            padding: 0px;
          }
          ::v-deep .el-table__header-wrapper{
            background-color: #987AFF;
              width: 100%;
          }
          ::v-deep .el-table thead{
            color: #fff;
            font-weight: 300;
          }
          ::v-deep .el-table{
            table-layout: auto !important;
          }
          ::v-deep .el-table__body{
            table-layout: auto !important;
          }
         ::v-deep .cell{
           font-family:myFont;
          }
        }
        ::v-deep .cell{
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          text-align: center;
        }
        // 用户名和位置列允许换行显示
        ::v-deep .el-table__body-wrapper .cell-wrap .cell{
          white-space: normal !important;
          text-overflow: initial !important;
          overflow: visible !important;
          word-break: break-all !important;
          text-align: center;
          padding: 8px 0;
          max-width: none !important;
        }
        ::v-deep .el-table__body-wrapper .cell-wrap td{
          white-space: normal !important;
          overflow: visible !important;
          height: auto !important;
          max-width: none !important;
        }
        ::v-deep .el-table__body-wrapper .cell-wrap .el-table__cell{
          height: auto !important;
          padding: 8px 0 !important;
          max-width: none !important;
        }
        ::v-deep .el-table__body-wrapper tr:hover .cell-wrap .cell{
          white-space: normal !important;
        }
        .cell-content-wrap{
          white-space: normal !important;
          word-break: break-all !important;
          word-wrap: break-word !important;
          text-align: center;
          line-height: 1.5;
          width: 100%;
          display: block;
          overflow: visible !important;
        }
       ::v-deep .el-table__header{
         width: 0;
          width: 100%;
        }
        .el-button{
          border: 1px solid #744dfe;
          background-color: #744dfe;
          color: #FFF;
          letter-spacing: 3PX;
        }
  }
  .locationOpenvalve {
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 92%;
    }
  }
    }
    .locationOpenvalve .el-form[data-v-9207be80]{
      display: flex;
      justify-content: flex-start;
    }
    .cycle{
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 94%;
    .el-dialog__body{
      padding: 10px 4px;
      .Periodic{
        display: flex;
        justify-content: space-between;
      }
      .time{
        .el-range-editor.el-input__inner{
          width: 56%;
        }
      }
      .block{
        display: flex;
        align-items: center;
        .el-date-editor.el-input, .el-date-editor.el-input__inner{
          width: 52%;
        }
        .el-select{
          width: 80px;
        }
      }
      .el-pagination{
        margin-top: 4px;
        white-space: initial;
      }
    }
    }
  }
  }
  .yyqxcals{
    .el-dialog{
      width: 80%;
    }
  }
  // 查询设备历史记录
  .cyclKai{
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 94%;
    .el-dialog__body{
      padding: 10px 4px;
      .Periodic{
        display: flex;
        justify-content: space-between;
      }
      .time{
        .el-range-editor.el-input__inner{
          width: 56%;
        }
      }
      .block{
        display: flex;
        align-items: center;
        .el-date-editor.el-input, .el-date-editor.el-input__inner{
          width: 52%;
        }
        .el-select{
          width: 80px;
        }
      }
      .el-pagination{
        margin-top: 4px;
        white-space: initial;
      }
    }
    }
  }
  }
  // 查询设备日用量
  .yyqxcals{
    .el-dialog__wrapper{
    ::v-deep .el-dialog{
    width: 94%;
    height: 85%;
    .dialog-footer{
      .el-pagination{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 10px;
      }
    }
    }
  }
  }
  // 录入表码
  .Number-table-codes{
    .el-dialog__wrapper{
      ::v-deep .el-dialog{
        width: 65%;
      }
    }
  }

  .moveab ::v-deep .el-table__body-wrapper,
  .moveab ::v-deep .el-table__header-wrapper{
    overflow-x: hidden !important;
  }
  .moveab ::v-deep .el-table .cell{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .moveab ::v-deep .mobile-op-btn{
    width: 100%;
    padding: 6px 6px !important;
    font-size: 11px !important;
    line-height: 1.1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }
  .mobile-detail-wrap{
    max-height: 52vh;
    overflow-y: auto;
  }
  .mobile-detail-row{
    display: flex;
    gap: 6px;
    padding: 5px 0;
    border-bottom: 1px dashed #eee;
    font-size: 12px;
    line-height: 1.4;
  }
  .mobile-detail-row .k{
    flex: 0 0 auto;
    color: #606266;
    white-space: nowrap;
  }
  .mobile-detail-row .v{
    flex: 1 1 auto;
    min-width: 0;
    word-break: break-all;
    color: #303133;
  }

  /* ===== 查询区手机端定制（仅 <=768 生效） ===== */
  .suso-desktop{
    display: none !important;
  }
  .suso-mobile{
    display: block !important;
    padding: 10px 10px 0 !important;
  }
  .suso-mobile .el-form{
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 6px 8px;
    width: 100%;
    margin: 0;
  }
  .suso-mobile .el-form + .el-form{
    margin-top: 6px;
  }
  .suso-mobile .el-form > .el-form-item{
    margin: 0 !important;
    min-width: 0;
  }
  .suso-mobile .elform{
    margin-left: 0 !important;
  }
  .suso-mobile .elform ::v-deep .el-form-item__label{
    display: none !important;
  }
  .suso-mobile .elform ::v-deep .el-form-item__content{
    margin-left: 0 !important;
    width: 100%;
  }
  .suso-mobile .el-input,
  .suso-mobile .el-select{
    width: 100% !important;
  }
  .suso-mobile ::v-deep .el-input__inner{
    height: 34px;
    line-height: 34px;
    font-size: 16px;
  }
  .suso-mobile .mobile-query-actions{
    display: block !important;
  }
  .suso-mobile .mobile-query-actions ::v-deep .el-form-item__content{
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    margin-left: 0 !important;
    width: 100%;
  }
  .suso-mobile .mobile-query-actions .formBtn{
    flex: 1 1 0;
    min-width: 0;
    margin-left: 0 !important;
    padding: 10px 8px !important;
    font-size: 12px !important;
    line-height: 1;
    letter-spacing: 2px;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  /* 手机端列表分页：与交款退款页一致，仅上一页/页码/下一页；居中可折行，禁止横向滑动 */
  .moveab ::v-deep .acc-pagination.el-pagination {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 6px 4px 10px;
    overflow-x: hidden;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 4px;
  }
  .moveab ::v-deep .acc-pagination.el-pagination .el-pagination__rightwrapper {
    float: none !important;
    margin-left: 0 !important;
  }
  .moveab ::v-deep .acc-pagination .el-pagination__total,
  .moveab ::v-deep .acc-pagination .el-pagination__sizes,
  .moveab ::v-deep .acc-pagination .el-pagination__jump {
    display: none;
  }
  .moveab ::v-deep .acc-pagination .btn-prev,
  .moveab ::v-deep .acc-pagination .btn-next,
  .moveab ::v-deep .acc-pagination .el-pager li {
    min-width: 26px;
    font-size: 12px;
  }

  /* 手机端弹框分页：设备进程、历史记录、设备日用量等（与交款退款一致，禁止横向滑动） */
  .T ::v-deep .dialog-acc-pagination.el-pagination {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 6px 2px 8px;
    overflow-x: hidden;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 4px;
  }
  .T ::v-deep .dialog-acc-pagination.el-pagination .el-pagination__rightwrapper {
    float: none !important;
    margin-left: 0 !important;
  }
  .T ::v-deep .dialog-acc-pagination .el-pagination__total,
  .T ::v-deep .dialog-acc-pagination .el-pagination__sizes,
  .T ::v-deep .dialog-acc-pagination .el-pagination__jump {
    display: none;
  }
  .T ::v-deep .dialog-acc-pagination .btn-prev,
  .T ::v-deep .dialog-acc-pagination .btn-next,
  .T ::v-deep .dialog-acc-pagination .el-pager li {
    min-width: 26px;
    font-size: 12px;
  }
  .T ::v-deep .el-dialog.wm-process-dialog .el-table__body-wrapper,
  .T ::v-deep .el-dialog.wm-process-dialog .el-table__header-wrapper,
  .T ::v-deep .el-dialog.wm-history-dialog .el-table__body-wrapper,
  .T ::v-deep .el-dialog.wm-history-dialog .el-table__header-wrapper,
  .T ::v-deep .el-dialog.wm-daily-usage-dialog .el-table__body-wrapper,
  .T ::v-deep .el-dialog.wm-daily-usage-dialog .el-table__header-wrapper {
    overflow-x: hidden !important;
  }

  /* 按钮区域弹窗：周期/定点上传、日/月冻结参数与数据 — 小屏纵向布局、可滚动、避免横向溢出 */
  .T ::v-deep .el-dialog.wm-btn-area-dialog {
    width: 92vw !important;
    max-width: 520px;
    margin: 4vh auto !important;
    box-sizing: border-box;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .el-dialog__header {
    padding: 12px 12px 8px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .el-dialog__title {
    font-size: 15px;
    line-height: 1.35;
    word-break: break-word;
    padding-right: 24px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .el-dialog__body {
    padding: 10px 12px;
    max-height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .el-dialog__footer {
    padding: 8px 12px 12px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .Periodic {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    justify-content: flex-start !important;
    gap: 8px;
    margin-bottom: 12px !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .Periodic > span,
  .T ::v-deep .el-dialog.wm-btn-area-dialog .Periodic > div {
    white-space: normal !important;
    word-break: break-word;
    font-size: 12px;
    line-height: 1.4;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .Periodic .el-checkbox {
    align-items: flex-start;
    white-space: normal;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .Periodic .el-checkbox__label {
    white-space: normal;
    line-height: 1.35;
    font-size: 12px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .time {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 8px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .time > span {
    font-size: 12px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .time .el-date-editor,
  .T ::v-deep .el-dialog.wm-btn-area-dialog .time .el-range-editor.el-input__inner {
    width: 100% !important;
    max-width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .time .el-button {
    width: 100%;
    margin-left: 0 !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .wm-interval-row {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 8px;
    margin-top: 12px !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .wm-interval-row > span {
    font-size: 12px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .wm-interval-row .el-input-number {
    width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .wm-interval-row .el-button {
    width: 100%;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .block {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 8px;
    flex-wrap: nowrap !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .block > span {
    font-size: 12px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .block .el-date-editor,
  .T ::v-deep .el-dialog.wm-btn-area-dialog .block .el-date-editor.el-input__inner {
    width: 100% !important;
    max-width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .block .el-input {
    width: 100% !important;
    max-width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .block .el-time-picker {
    width: 100% !important;
    max-width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .block .el-select {
    width: 100% !important;
    max-width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .block .el-button {
    width: 100%;
    margin-left: 0 !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dingdianfas {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dingdianfas > span {
    font-size: 12px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dingdianfas > .el-select {
    width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dingdianfas .y1,
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dingdianfas .y2 {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    width: 100%;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dingdianfas .y1 .el-select,
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dingdianfas .y2 .el-select,
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dingdianfas .wm-dingdian-hour-select {
    width: 100% !important;
    max-width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .zhuos {
    font-size: 11px;
    line-height: 1.45;
    margin-top: 10px;
    padding: 0 2px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .rdojie {
    margin-top: 10px;
    max-height: 42vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dialog-footer {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .T ::v-deep .el-dialog.wm-btn-area-dialog .dialog-footer .el-button {
    width: 100%;
    margin: 0 !important;
    letter-spacing: 0 !important;
  }

  /* 用水曲线弹窗：手机端加宽、工具栏纵向排布、内容区可滚动（不影响电脑端 width=70%） */
  .T ::v-deep .el-dialog.wm-yyqx-dialog {
    width: 96vw !important;
    max-width: 100%;
    margin: 2vh auto !important;
    height: auto !important;
    max-height: 92vh;
    box-sizing: border-box;
  }
  .T ::v-deep .el-dialog.wm-yyqx-dialog .el-dialog__header {
    padding: 12px 12px 8px;
  }
  .T ::v-deep .el-dialog.wm-yyqx-dialog .el-dialog__title {
    font-size: 15px;
    line-height: 1.35;
    word-break: break-word;
    padding-right: 28px;
  }
  .T ::v-deep .el-dialog.wm-yyqx-dialog .el-dialog__body {
    padding: 10px 8px 14px;
    max-height: 78vh;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
  }
  .T ::v-deep .el-dialog.wm-yyqx-dialog .wm-yyqx-toolbar.block {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 10px;
  }
  .T ::v-deep .el-dialog.wm-yyqx-dialog .wm-yyqx-toolbar .el-date-editor.el-input,
  .T ::v-deep .el-dialog.wm-yyqx-dialog .wm-yyqx-toolbar .el-date-editor.el-input__inner {
    width: 100% !important;
    max-width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-yyqx-dialog .wm-yyqx-toolbar .el-button {
    width: 100%;
    margin-left: 0 !important;
  }
  .T ::v-deep .el-dialog.wm-yyqx-dialog .wm-yyqx-chart.rdojie {
    margin-top: 8px;
    min-height: 220px;
    max-height: 50vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .T ::v-deep .el-dialog.wm-yyqx-dialog .wm-yyqx-chart .el-card {
    width: 100%;
    box-sizing: border-box;
  }

  /* 设备日用量弹窗：手机端工具栏纵向、日期框全宽；日期面板样式见文件末尾非 scoped */
  .T ::v-deep .el-dialog.wm-daily-usage-dialog {
    width: 92vw !important;
    max-width: 100%;
    height: auto !important;
    max-height: 90vh;
    box-sizing: border-box;
  }
  .T ::v-deep .el-dialog.wm-daily-usage-dialog .el-dialog__body {
    max-height: 78vh;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding: 12px 10px;
    box-sizing: border-box;
  }
  .T ::v-deep .el-dialog.wm-daily-usage-dialog .wm-daily-usage-toolbar {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    width: 100%;
  }
  .T ::v-deep .el-dialog.wm-daily-usage-dialog .wm-daily-usage-toolbar .el-range-editor.el-input__inner {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .T ::v-deep .el-dialog.wm-daily-usage-dialog .wm-daily-usage-toolbar .el-button {
    width: 100%;
    margin-left: 0 !important;
  }

  /* 录入表码：手机端全宽输入、16px 字号（避免 iOS 聚焦/缩放异常） */
  .T ::v-deep .el-dialog.wm-table-code-dialog {
    width: 88vw !important;
    max-width: 420px;
    box-sizing: border-box;
  }
  .T ::v-deep .el-dialog.wm-table-code-dialog .el-dialog__body {
    padding: 16px 14px;
    overflow: visible;
  }
  .T ::v-deep .el-dialog.wm-table-code-dialog .wm-table-code-body {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    width: 100%;
  }
  .T ::v-deep .el-dialog.wm-table-code-dialog .wm-table-code-label {
    font-size: 14px;
    line-height: 1.4;
  }
  .T ::v-deep .el-dialog.wm-table-code-dialog .wm-table-code-input {
    width: 100% !important;
  }
  .T ::v-deep .el-dialog.wm-table-code-dialog .wm-table-code-input .el-input__inner {
    font-size: 16px !important;
    line-height: 1.35;
    height: 44px;
    box-sizing: border-box;
    touch-action: manipulation;
    -webkit-appearance: none;
    appearance: none;
  }
    }
</style>
<style lang="less">
/* 设备日用量日期范围面板挂在 body，需非 scoped；仅小屏 */
@media (max-width: 768px) {
  .el-picker-panel.el-date-range-picker.wm-daily-range-popper,
  .el-date-range-picker.el-picker-panel.wm-daily-range-popper {
    max-width: 96vw !important;
    width: 96vw !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }
  .wm-daily-range-popper .el-picker-panel__body {
    min-width: 0 !important;
  }
  .wm-daily-range-popper .el-picker-panel__body-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
